//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import { DateTime, Duration } from "luxon";

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class AccountClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:7332";
    }

    token(userLogin: UserLoginDTO): Observable<UserTokenDTO> {
        let url_ = this.baseUrl + "/Token";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userLogin);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserTokenDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserTokenDTO>;
        }));
    }

    protected processToken(response: HttpResponseBase): Observable<UserTokenDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserTokenDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClientClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:7332";
    }

    createClient(client: CreateClientDTO): Observable<ClientDTO | null> {
        let url_ = this.baseUrl + "/api/Client/CreateClient";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(client);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateClient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientDTO | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientDTO | null>;
        }));
    }

    protected processCreateClient(response: HttpResponseBase): Observable<ClientDTO | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ClientDTO.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deactivateClient(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Client/DeactivateClient?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeactivateClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeactivateClient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeactivateClient(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getClient(id: number | undefined): Observable<ClientDTO> {
        let url_ = this.baseUrl + "/api/Client/GetClient?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientDTO>;
        }));
    }

    protected processGetClient(response: HttpResponseBase): Observable<ClientDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchClients(filters: FilterDTO[] | undefined, skip: number | undefined, take: number | undefined, sortBy: string | undefined, sortDirection: SortDirection | undefined): Observable<PagedResultDTOOfClientDTO | null> {
        let url_ = this.baseUrl + "/api/Client/SearchClients?";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchClients(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchClients(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfClientDTO | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfClientDTO | null>;
        }));
    }

    protected processSearchClients(response: HttpResponseBase): Observable<PagedResultDTOOfClientDTO | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDTOOfClientDTO.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateClient(client: UpdateClientDTO): Observable<ClientDTO> {
        let url_ = this.baseUrl + "/api/Client/UpdateClient";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(client);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateClient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientDTO>;
        }));
    }

    protected processUpdateClient(response: HttpResponseBase): Observable<ClientDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CollectorClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:7332";
    }

    register(request: CollectorRegistrationRequestDto): Observable<CollectorRegistrationResponseDto> {
        let url_ = this.baseUrl + "/api/collector/Register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegister(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CollectorRegistrationResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CollectorRegistrationResponseDto>;
        }));
    }

    protected processRegister(response: HttpResponseBase): Observable<CollectorRegistrationResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CollectorRegistrationResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    heartbeat(request: CollectorHeartbeatRequestDto): Observable<void> {
        let url_ = this.baseUrl + "/api/collector/Heartbeat";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHeartbeat(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHeartbeat(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processHeartbeat(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    signalAvailability(request: SignalAvailabilityReportRequestDto): Observable<IngestionAckDto> {
        let url_ = this.baseUrl + "/api/collector/SignalAvailability";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSignalAvailability(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSignalAvailability(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IngestionAckDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IngestionAckDto>;
        }));
    }

    protected processSignalAvailability(response: HttpResponseBase): Observable<IngestionAckDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IngestionAckDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ConfigurationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:7332";
    }

    get(): Observable<CollectorConfigurationDto> {
        let url_ = this.baseUrl + "/api/configuration";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CollectorConfigurationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CollectorConfigurationDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CollectorConfigurationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CollectorConfigurationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DeviceInfoClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:7332";
    }

    registerDeviceInfo(model: RegisterDeviceInfoDTO): Observable<void> {
        let url_ = this.baseUrl + "/api/DeviceInfo/RegisterDeviceInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegisterDeviceInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegisterDeviceInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRegisterDeviceInfo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    unregisterDeviceInfo(model: UnregisterDeviceInfoDTO): Observable<void> {
        let url_ = this.baseUrl + "/api/DeviceInfo/UnregisterDeviceInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnregisterDeviceInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnregisterDeviceInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnregisterDeviceInfo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateDevicePreferences(model: UpdateDevicePreferencesDTO): Observable<void> {
        let url_ = this.baseUrl + "/api/DeviceInfo/UpdateDevicePreferences";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDevicePreferences(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDevicePreferences(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateDevicePreferences(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DiagnosticsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:7332";
    }

    events(body: Blob | null | undefined): Observable<IngestionAckDto> {
        let url_ = this.baseUrl + "/api/diagnostics/Events";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = body;

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "multipart/form-data",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEvents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEvents(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IngestionAckDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IngestionAckDto>;
        }));
    }

    protected processEvents(response: HttpResponseBase): Observable<IngestionAckDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IngestionAckDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = IngestionAckDto.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PushNotificationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:7332";
    }

    sendPushNotification(model: SendPushNotificationDTO): Observable<void> {
        let url_ = this.baseUrl + "/api/PushNotification/SendPushNotification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendPushNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendPushNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendPushNotification(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SamplingProfileClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:7332";
    }

    searchSamplingProfiles(filters: FilterDTO[] | undefined, skip: number | undefined, take: number | undefined, sortBy: string | undefined, sortDirection: SortDirection | undefined): Observable<PagedResultDTOOfSamplingProfileConfigDTO | null> {
        let url_ = this.baseUrl + "/api/SamplingProfile/SearchSamplingProfiles?";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchSamplingProfiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchSamplingProfiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfSamplingProfileConfigDTO | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfSamplingProfileConfigDTO | null>;
        }));
    }

    protected processSearchSamplingProfiles(response: HttpResponseBase): Observable<PagedResultDTOOfSamplingProfileConfigDTO | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDTOOfSamplingProfileConfigDTO.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSamplingProfile(id: number | undefined): Observable<SamplingProfileConfigDTO> {
        let url_ = this.baseUrl + "/api/SamplingProfile/GetSamplingProfile?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSamplingProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSamplingProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SamplingProfileConfigDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SamplingProfileConfigDTO>;
        }));
    }

    protected processGetSamplingProfile(response: HttpResponseBase): Observable<SamplingProfileConfigDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SamplingProfileConfigDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createSamplingProfile(profile: CreateSamplingProfileConfigDTO): Observable<SamplingProfileConfigDTO | null> {
        let url_ = this.baseUrl + "/api/SamplingProfile/CreateSamplingProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(profile);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSamplingProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSamplingProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SamplingProfileConfigDTO | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SamplingProfileConfigDTO | null>;
        }));
    }

    protected processCreateSamplingProfile(response: HttpResponseBase): Observable<SamplingProfileConfigDTO | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SamplingProfileConfigDTO.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateSamplingProfile(profile: UpdateSamplingProfileConfigDTO): Observable<SamplingProfileConfigDTO | null> {
        let url_ = this.baseUrl + "/api/SamplingProfile/UpdateSamplingProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(profile);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSamplingProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSamplingProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SamplingProfileConfigDTO | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SamplingProfileConfigDTO | null>;
        }));
    }

    protected processUpdateSamplingProfile(response: HttpResponseBase): Observable<SamplingProfileConfigDTO | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SamplingProfileConfigDTO.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteSamplingProfile(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/SamplingProfile/DeleteSamplingProfile?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteSamplingProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSamplingProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteSamplingProfile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    cloneSamplingProfile(sourceProfileId: number | undefined, name: string | undefined, description: string | null | undefined): Observable<SamplingProfileConfigDTO> {
        let url_ = this.baseUrl + "/api/SamplingProfile/CloneSamplingProfile?";
        if (sourceProfileId === null)
            throw new globalThis.Error("The parameter 'sourceProfileId' cannot be null.");
        else if (sourceProfileId !== undefined)
            url_ += "sourceProfileId=" + encodeURIComponent("" + sourceProfileId) + "&";
        if (name === null)
            throw new globalThis.Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (description !== undefined && description !== null)
            url_ += "description=" + encodeURIComponent("" + description) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCloneSamplingProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCloneSamplingProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SamplingProfileConfigDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SamplingProfileConfigDTO>;
        }));
    }

    protected processCloneSamplingProfile(response: HttpResponseBase): Observable<SamplingProfileConfigDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SamplingProfileConfigDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    assignProfileToVehicle(request: AssignSamplingProfileDTO): Observable<void> {
        let url_ = this.baseUrl + "/api/SamplingProfile/AssignProfileToVehicle";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignProfileToVehicle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignProfileToVehicle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAssignProfileToVehicle(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAssignedVehicles(samplingProfileId: number | undefined): Observable<VehicleListDTO[]> {
        let url_ = this.baseUrl + "/api/SamplingProfile/GetAssignedVehicles?";
        if (samplingProfileId === null)
            throw new globalThis.Error("The parameter 'samplingProfileId' cannot be null.");
        else if (samplingProfileId !== undefined)
            url_ += "samplingProfileId=" + encodeURIComponent("" + samplingProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssignedVehicles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssignedVehicles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VehicleListDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VehicleListDTO[]>;
        }));
    }

    protected processGetAssignedVehicles(response: HttpResponseBase): Observable<VehicleListDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VehicleListDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSignalAvailability(vehicleId: number | undefined): Observable<VehicleSignalAvailabilityDTO> {
        let url_ = this.baseUrl + "/api/SamplingProfile/GetSignalAvailability?";
        if (vehicleId === null)
            throw new globalThis.Error("The parameter 'vehicleId' cannot be null.");
        else if (vehicleId !== undefined)
            url_ += "vehicleId=" + encodeURIComponent("" + vehicleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSignalAvailability(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSignalAvailability(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VehicleSignalAvailabilityDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VehicleSignalAvailabilityDTO>;
        }));
    }

    protected processGetSignalAvailability(response: HttpResponseBase): Observable<VehicleSignalAvailabilityDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VehicleSignalAvailabilityDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SignalClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:7332";
    }

    get(): Observable<SignalCatalogDto> {
        let url_ = this.baseUrl + "/api/signals";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SignalCatalogDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SignalCatalogDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SignalCatalogDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SignalCatalogDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchSignalDefinitions(filters: FilterDTO[] | undefined, skip: number | undefined, take: number | undefined, sortBy: string | undefined, sortDirection: SortDirection | undefined): Observable<PagedResultDTOOfSignalDefinitionConfigDTO | null> {
        let url_ = this.baseUrl + "/api/signals/search?";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchSignalDefinitions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchSignalDefinitions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfSignalDefinitionConfigDTO | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfSignalDefinitionConfigDTO | null>;
        }));
    }

    protected processSearchSignalDefinitions(response: HttpResponseBase): Observable<PagedResultDTOOfSignalDefinitionConfigDTO | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDTOOfSignalDefinitionConfigDTO.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class StatisticsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:7332";
    }

    getRunningTotals(vehicleId: number | undefined): Observable<VehicleRunningTotalDTO[]> {
        let url_ = this.baseUrl + "/api/statistics/GetRunningTotals?";
        if (vehicleId === null)
            throw new globalThis.Error("The parameter 'vehicleId' cannot be null.");
        else if (vehicleId !== undefined)
            url_ += "vehicleId=" + encodeURIComponent("" + vehicleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRunningTotals(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRunningTotals(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VehicleRunningTotalDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VehicleRunningTotalDTO[]>;
        }));
    }

    protected processGetRunningTotals(response: HttpResponseBase): Observable<VehicleRunningTotalDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VehicleRunningTotalDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchTrips(filters: FilterDTO[] | undefined, vehicleId: number | undefined, skip: number | undefined, take: number | undefined, sortBy: string | undefined, sortDirection: SortDirection | undefined): Observable<PagedResultDTOOfTripDTO | null> {
        let url_ = this.baseUrl + "/api/statistics/SearchTrips?";
        if (vehicleId === null)
            throw new globalThis.Error("The parameter 'vehicleId' cannot be null.");
        else if (vehicleId !== undefined)
            url_ += "vehicleId=" + encodeURIComponent("" + vehicleId) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchTrips(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchTrips(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfTripDTO | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfTripDTO | null>;
        }));
    }

    protected processSearchTrips(response: HttpResponseBase): Observable<PagedResultDTOOfTripDTO | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDTOOfTripDTO.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTrip(tripId: number | undefined): Observable<TripDetailDTO> {
        let url_ = this.baseUrl + "/api/statistics/GetTrip?";
        if (tripId === null)
            throw new globalThis.Error("The parameter 'tripId' cannot be null.");
        else if (tripId !== undefined)
            url_ += "tripId=" + encodeURIComponent("" + tripId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTrip(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTrip(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TripDetailDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TripDetailDTO>;
        }));
    }

    protected processGetTrip(response: HttpResponseBase): Observable<TripDetailDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TripDetailDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPeriodicStatistics(vehicleId: number | undefined, periodType: PeriodType | undefined, fromUtc: DateTime | undefined, toUtc: DateTime | undefined): Observable<PeriodicStatisticDTO[]> {
        let url_ = this.baseUrl + "/api/statistics/GetPeriodicStatistics?";
        if (vehicleId === null)
            throw new globalThis.Error("The parameter 'vehicleId' cannot be null.");
        else if (vehicleId !== undefined)
            url_ += "vehicleId=" + encodeURIComponent("" + vehicleId) + "&";
        if (periodType === null)
            throw new globalThis.Error("The parameter 'periodType' cannot be null.");
        else if (periodType !== undefined)
            url_ += "periodType=" + encodeURIComponent("" + periodType) + "&";
        if (fromUtc === null)
            throw new globalThis.Error("The parameter 'fromUtc' cannot be null.");
        else if (fromUtc !== undefined)
            url_ += "fromUtc=" + encodeURIComponent(fromUtc ? "" + fromUtc.toString() : "") + "&";
        if (toUtc === null)
            throw new globalThis.Error("The parameter 'toUtc' cannot be null.");
        else if (toUtc !== undefined)
            url_ += "toUtc=" + encodeURIComponent(toUtc ? "" + toUtc.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPeriodicStatistics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPeriodicStatistics(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PeriodicStatisticDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PeriodicStatisticDTO[]>;
        }));
    }

    protected processGetPeriodicStatistics(response: HttpResponseBase): Observable<PeriodicStatisticDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PeriodicStatisticDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchEvents(filters: FilterDTO[] | undefined, vehicleId: number | undefined, skip: number | undefined, take: number | undefined, sortBy: string | undefined, sortDirection: SortDirection | undefined): Observable<PagedResultDTOOfStatisticEventDTO | null> {
        let url_ = this.baseUrl + "/api/statistics/SearchEvents?";
        if (vehicleId === null)
            throw new globalThis.Error("The parameter 'vehicleId' cannot be null.");
        else if (vehicleId !== undefined)
            url_ += "vehicleId=" + encodeURIComponent("" + vehicleId) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchEvents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchEvents(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfStatisticEventDTO | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfStatisticEventDTO | null>;
        }));
    }

    protected processSearchEvents(response: HttpResponseBase): Observable<PagedResultDTOOfStatisticEventDTO | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDTOOfStatisticEventDTO.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchDiagnosticEvents(filters: FilterDTO[] | undefined, vehicleId: number | undefined, skip: number | undefined, take: number | undefined, sortBy: string | undefined, sortDirection: SortDirection | undefined): Observable<PagedResultDTOOfDiagnosticEventDTO | null> {
        let url_ = this.baseUrl + "/api/statistics/SearchDiagnosticEvents?";
        if (vehicleId === null)
            throw new globalThis.Error("The parameter 'vehicleId' cannot be null.");
        else if (vehicleId !== undefined)
            url_ += "vehicleId=" + encodeURIComponent("" + vehicleId) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchDiagnosticEvents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchDiagnosticEvents(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfDiagnosticEventDTO | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfDiagnosticEventDTO | null>;
        }));
    }

    protected processSearchDiagnosticEvents(response: HttpResponseBase): Observable<PagedResultDTOOfDiagnosticEventDTO | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDTOOfDiagnosticEventDTO.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getChartData(vehicleId: number | undefined, statistic: OnDemandStatistic | undefined, fromUtc: DateTime | undefined, toUtc: DateTime | undefined): Observable<ChartDataDTO> {
        let url_ = this.baseUrl + "/api/statistics/GetChartData?";
        if (vehicleId === null)
            throw new globalThis.Error("The parameter 'vehicleId' cannot be null.");
        else if (vehicleId !== undefined)
            url_ += "vehicleId=" + encodeURIComponent("" + vehicleId) + "&";
        if (statistic === null)
            throw new globalThis.Error("The parameter 'statistic' cannot be null.");
        else if (statistic !== undefined)
            url_ += "statistic=" + encodeURIComponent("" + statistic) + "&";
        if (fromUtc === null)
            throw new globalThis.Error("The parameter 'fromUtc' cannot be null.");
        else if (fromUtc !== undefined)
            url_ += "fromUtc=" + encodeURIComponent(fromUtc ? "" + fromUtc.toString() : "") + "&";
        if (toUtc === null)
            throw new globalThis.Error("The parameter 'toUtc' cannot be null.");
        else if (toUtc !== undefined)
            url_ += "toUtc=" + encodeURIComponent(toUtc ? "" + toUtc.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetChartData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChartData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChartDataDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChartDataDTO>;
        }));
    }

    protected processGetChartData(response: HttpResponseBase): Observable<ChartDataDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChartDataDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    recomputeScheduled(request: RecomputeScheduledRequestDTO): Observable<void> {
        let url_ = this.baseUrl + "/api/statistics/RecomputeScheduled";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRecomputeScheduled(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRecomputeScheduled(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRecomputeScheduled(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TelemetryClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:7332";
    }

    upload(body: Blob | null | undefined): Observable<IngestionAckDto> {
        let url_ = this.baseUrl + "/api/telemetry/Upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = body;

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "multipart/form-data",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IngestionAckDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IngestionAckDto>;
        }));
    }

    protected processUpload(response: HttpResponseBase): Observable<IngestionAckDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IngestionAckDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = IngestionAckDto.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ThemeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:7332";
    }

    getClientTheme(clientId: number | undefined): Observable<ClientThemeDTO> {
        let url_ = this.baseUrl + "/api/Theme/GetClientTheme?";
        if (clientId === null)
            throw new globalThis.Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClientTheme(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientTheme(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientThemeDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientThemeDTO>;
        }));
    }

    protected processGetClientTheme(response: HttpResponseBase): Observable<ClientThemeDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientThemeDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveClientTheme(clientId: number | undefined, theme: ClientThemeDTO): Observable<ClientThemeDTO> {
        let url_ = this.baseUrl + "/api/Theme/SaveClientTheme?";
        if (clientId === null)
            throw new globalThis.Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(theme);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveClientTheme(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveClientTheme(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientThemeDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientThemeDTO>;
        }));
    }

    protected processSaveClientTheme(response: HttpResponseBase): Observable<ClientThemeDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientThemeDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserAccountClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:7332";
    }

    info(): Observable<UserInfoDTO> {
        let url_ = this.baseUrl + "/api/UserAccount/Info";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserInfoDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserInfoDTO>;
        }));
    }

    protected processInfo(response: HttpResponseBase): Observable<UserInfoDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserInfoDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchUsers(filters: FilterDTO[] | undefined, clientId: number | null | undefined, skip: number | undefined, take: number | undefined, sortBy: string | undefined, sortDirection: SortDirection | undefined): Observable<PagedResultDTOOfUserInfoDTO> {
        let url_ = this.baseUrl + "/api/UserAccount/SearchUsers?";
        if (clientId !== undefined && clientId !== null)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfUserInfoDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfUserInfoDTO>;
        }));
    }

    protected processSearchUsers(response: HttpResponseBase): Observable<PagedResultDTOOfUserInfoDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDTOOfUserInfoDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setUserLanguage(language: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/UserAccount/SetUserLanguage?";
        if (language === null)
            throw new globalThis.Error("The parameter 'language' cannot be null.");
        else if (language !== undefined)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetUserLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetUserLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetUserLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateUser(model: UpdateUserInfoDTO): Observable<UserInfoDTO> {
        let url_ = this.baseUrl + "/api/UserAccount/UpdateUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserInfoDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserInfoDTO>;
        }));
    }

    protected processUpdateUser(response: HttpResponseBase): Observable<UserInfoDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserInfoDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addMobileUser(model: CreateMobileUserDTO): Observable<UserInfoDTO> {
        let url_ = this.baseUrl + "/api/UserAccount/AddMobileUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddMobileUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddMobileUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserInfoDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserInfoDTO>;
        }));
    }

    protected processAddMobileUser(response: HttpResponseBase): Observable<UserInfoDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserInfoDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    regenerateAccessCode(userId: string | undefined): Observable<UserInfoDTO> {
        let url_ = this.baseUrl + "/api/UserAccount/RegenerateAccessCode?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegenerateAccessCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegenerateAccessCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserInfoDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserInfoDTO>;
        }));
    }

    protected processRegenerateAccessCode(response: HttpResponseBase): Observable<UserInfoDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserInfoDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addUser(model: CreateUserDTO): Observable<UserInfoDTO> {
        let url_ = this.baseUrl + "/api/UserAccount/AddUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserInfoDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserInfoDTO>;
        }));
    }

    protected processAddUser(response: HttpResponseBase): Observable<UserInfoDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserInfoDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    logout(): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/UserAccount/Logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogout(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogout(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processLogout(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    changePassword(model: ChangePasswordDTO): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/UserAccount/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processChangePassword(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setPassword(model: SetPasswordDTO): Observable<void> {
        let url_ = this.baseUrl + "/api/UserAccount/SetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetPassword(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    forgotPassword(model: ForgotPasswordDTO): Observable<void> {
        let url_ = this.baseUrl + "/api/UserAccount/ForgotPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processForgotPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processForgotPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processForgotPassword(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMinimumClientVersion(): Observable<MinimumClientVersionDTO> {
        let url_ = this.baseUrl + "/api/UserAccount/GetMinimumClientVersion";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMinimumClientVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMinimumClientVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MinimumClientVersionDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MinimumClientVersionDTO>;
        }));
    }

    protected processGetMinimumClientVersion(response: HttpResponseBase): Observable<MinimumClientVersionDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MinimumClientVersionDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class VehicleClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:7332";
    }

    metadata(request: VehicleMetadataRequestDto): Observable<IngestionAckDto> {
        let url_ = this.baseUrl + "/api/vehicle/Metadata";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMetadata(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMetadata(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IngestionAckDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IngestionAckDto>;
        }));
    }

    protected processMetadata(response: HttpResponseBase): Observable<IngestionAckDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IngestionAckDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchVehicles(filters: FilterDTO[] | undefined, skip: number | undefined, take: number | undefined, sortBy: string | undefined, sortDirection: SortDirection | undefined): Observable<PagedResultDTOOfVehicleListDTO | null> {
        let url_ = this.baseUrl + "/api/vehicle/SearchVehicles?";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchVehicles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchVehicles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDTOOfVehicleListDTO | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDTOOfVehicleListDTO | null>;
        }));
    }

    protected processSearchVehicles(response: HttpResponseBase): Observable<PagedResultDTOOfVehicleListDTO | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDTOOfVehicleListDTO.fromJS(resultData200) : null as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMyVehicles(): Observable<VehicleListDTO[]> {
        let url_ = this.baseUrl + "/api/vehicle/GetMyVehicles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyVehicles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyVehicles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VehicleListDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VehicleListDTO[]>;
        }));
    }

    protected processGetMyVehicles(response: HttpResponseBase): Observable<VehicleListDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VehicleListDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class UserTokenDTO implements IUserTokenDTO {
    access_token?: string | undefined;
    token_type?: string | undefined;
    username?: string | undefined;
    clientId?: string | undefined;
    refresh_token?: string | undefined;
    refreshTokenExpiresIn!: number;
    expires_in!: number;
    expires?: string | undefined;

    constructor(data?: IUserTokenDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.access_token = _data["access_token"];
            this.token_type = _data["token_type"];
            this.username = _data["username"];
            this.clientId = _data["clientId"];
            this.refresh_token = _data["refresh_token"];
            this.refreshTokenExpiresIn = _data["refreshTokenExpiresIn"];
            this.expires_in = _data["expires_in"];
            this.expires = _data["expires"];
        }
    }

    static fromJS(data: any): UserTokenDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserTokenDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["access_token"] = this.access_token;
        data["token_type"] = this.token_type;
        data["username"] = this.username;
        data["clientId"] = this.clientId;
        data["refresh_token"] = this.refresh_token;
        data["refreshTokenExpiresIn"] = this.refreshTokenExpiresIn;
        data["expires_in"] = this.expires_in;
        data["expires"] = this.expires;
        return data;
    }
}

export interface IUserTokenDTO {
    access_token?: string | undefined;
    token_type?: string | undefined;
    username?: string | undefined;
    clientId?: string | undefined;
    refresh_token?: string | undefined;
    refreshTokenExpiresIn: number;
    expires_in: number;
    expires?: string | undefined;
}

export class UserLoginDTO implements IUserLoginDTO {
    userName?: string | undefined;
    password?: string | undefined;
    grant_Type?: string | undefined;
    client_Id?: string | undefined;
    client_Secret?: string | undefined;
    refresh_Token?: string | undefined;

    constructor(data?: IUserLoginDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.password = _data["password"];
            this.grant_Type = _data["grant_Type"];
            this.client_Id = _data["client_Id"];
            this.client_Secret = _data["client_Secret"];
            this.refresh_Token = _data["refresh_Token"];
        }
    }

    static fromJS(data: any): UserLoginDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["password"] = this.password;
        data["grant_Type"] = this.grant_Type;
        data["client_Id"] = this.client_Id;
        data["client_Secret"] = this.client_Secret;
        data["refresh_Token"] = this.refresh_Token;
        return data;
    }
}

export interface IUserLoginDTO {
    userName?: string | undefined;
    password?: string | undefined;
    grant_Type?: string | undefined;
    client_Id?: string | undefined;
    client_Secret?: string | undefined;
    refresh_Token?: string | undefined;
}

export class ClientDTO implements IClientDTO {
    id!: number;
    address?: string | undefined;
    city?: string | undefined;
    email?: string | undefined;
    name?: string | undefined;
    phoneNumber?: string | undefined;
    zip?: string | undefined;
    isActive!: boolean;

    constructor(data?: IClientDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.email = _data["email"];
            this.name = _data["name"];
            this.phoneNumber = _data["phoneNumber"];
            this.zip = _data["zip"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): ClientDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ClientDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["address"] = this.address;
        data["city"] = this.city;
        data["email"] = this.email;
        data["name"] = this.name;
        data["phoneNumber"] = this.phoneNumber;
        data["zip"] = this.zip;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IClientDTO {
    id: number;
    address?: string | undefined;
    city?: string | undefined;
    email?: string | undefined;
    name?: string | undefined;
    phoneNumber?: string | undefined;
    zip?: string | undefined;
    isActive: boolean;
}

export class CreateClientDTO implements ICreateClientDTO {
    address?: string | undefined;
    city?: string | undefined;
    email?: string | undefined;
    name!: string;
    phoneNumber?: string | undefined;
    zip?: string | undefined;

    constructor(data?: ICreateClientDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address = _data["address"];
            this.city = _data["city"];
            this.email = _data["email"];
            this.name = _data["name"];
            this.phoneNumber = _data["phoneNumber"];
            this.zip = _data["zip"];
        }
    }

    static fromJS(data: any): CreateClientDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateClientDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        data["city"] = this.city;
        data["email"] = this.email;
        data["name"] = this.name;
        data["phoneNumber"] = this.phoneNumber;
        data["zip"] = this.zip;
        return data;
    }
}

export interface ICreateClientDTO {
    address?: string | undefined;
    city?: string | undefined;
    email?: string | undefined;
    name: string;
    phoneNumber?: string | undefined;
    zip?: string | undefined;
}

export class PagedResultDTOOfClientDTO implements IPagedResultDTOOfClientDTO {
    items?: ClientDTO[] | undefined;
    totalNumberOfItems!: number;

    constructor(data?: IPagedResultDTOOfClientDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ClientDTO.fromJS(item));
            }
            this.totalNumberOfItems = _data["totalNumberOfItems"];
        }
    }

    static fromJS(data: any): PagedResultDTOOfClientDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDTOOfClientDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalNumberOfItems"] = this.totalNumberOfItems;
        return data;
    }
}

export interface IPagedResultDTOOfClientDTO {
    items?: ClientDTO[] | undefined;
    totalNumberOfItems: number;
}

export class FilterDTO implements IFilterDTO {
    isComplex!: boolean;
    condition?: FilterCondition | undefined;
    field?: string | undefined;
    operator?: FilterOperator | undefined;
    value?: string | undefined;
    predicates?: FilterDTO[] | undefined;

    constructor(data?: IFilterDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isComplex = _data["isComplex"];
            this.condition = _data["condition"];
            this.field = _data["field"];
            this.operator = _data["operator"];
            this.value = _data["value"];
            if (Array.isArray(_data["predicates"])) {
                this.predicates = [] as any;
                for (let item of _data["predicates"])
                    this.predicates!.push(FilterDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FilterDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isComplex"] = this.isComplex;
        data["condition"] = this.condition;
        data["field"] = this.field;
        data["operator"] = this.operator;
        data["value"] = this.value;
        if (Array.isArray(this.predicates)) {
            data["predicates"] = [];
            for (let item of this.predicates)
                data["predicates"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFilterDTO {
    isComplex: boolean;
    condition?: FilterCondition | undefined;
    field?: string | undefined;
    operator?: FilterOperator | undefined;
    value?: string | undefined;
    predicates?: FilterDTO[] | undefined;
}

export enum FilterCondition {
    And = 0,
    Or = 1,
}

export enum FilterOperator {
    StartsWith = 0,
    EndsWith = 1,
    Contains = 2,
    Equal = 3,
    NotEqual = 4,
    GreaterThan = 5,
    GreaterThanOrEqual = 6,
    LessThan = 7,
    LessThanOrEqual = 8,
    IsNull = 9,
    IsNotNull = 10,
    Any = 11,
    None = 12,
    Empty = 13,
    NotEmpty = 14,
    DoesNotStartWith = 15,
    DoesNotEndWith = 16,
    DoesNotContain = 17,
}

export enum SortDirection {
    Ascending = 0,
    Descending = 1,
}

export class UpdateClientDTO implements IUpdateClientDTO {
    id!: number;
    address?: string | undefined;
    city?: string | undefined;
    email?: string | undefined;
    name?: string | undefined;
    phoneNumber?: string | undefined;
    zip?: string | undefined;
    isActive?: boolean | undefined;

    constructor(data?: IUpdateClientDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.email = _data["email"];
            this.name = _data["name"];
            this.phoneNumber = _data["phoneNumber"];
            this.zip = _data["zip"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): UpdateClientDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClientDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["address"] = this.address;
        data["city"] = this.city;
        data["email"] = this.email;
        data["name"] = this.name;
        data["phoneNumber"] = this.phoneNumber;
        data["zip"] = this.zip;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IUpdateClientDTO {
    id: number;
    address?: string | undefined;
    city?: string | undefined;
    email?: string | undefined;
    name?: string | undefined;
    phoneNumber?: string | undefined;
    zip?: string | undefined;
    isActive?: boolean | undefined;
}

export class CollectorRegistrationResponseDto implements ICollectorRegistrationResponseDto {
    collectorId!: string;
    alreadyRegistered!: boolean;

    constructor(data?: ICollectorRegistrationResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.collectorId = _data["collectorId"];
            this.alreadyRegistered = _data["alreadyRegistered"];
        }
    }

    static fromJS(data: any): CollectorRegistrationResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CollectorRegistrationResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["collectorId"] = this.collectorId;
        data["alreadyRegistered"] = this.alreadyRegistered;
        return data;
    }
}

export interface ICollectorRegistrationResponseDto {
    collectorId: string;
    alreadyRegistered: boolean;
}

export class CollectorRegistrationRequestDto implements ICollectorRegistrationRequestDto {
    collectorId!: string;
    collectorVersion!: string;
    serialNumber?: string | undefined;
    capabilities?: string | undefined;

    constructor(data?: ICollectorRegistrationRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.collectorId = _data["collectorId"];
            this.collectorVersion = _data["collectorVersion"];
            this.serialNumber = _data["serialNumber"];
            this.capabilities = _data["capabilities"];
        }
    }

    static fromJS(data: any): CollectorRegistrationRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CollectorRegistrationRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["collectorId"] = this.collectorId;
        data["collectorVersion"] = this.collectorVersion;
        data["serialNumber"] = this.serialNumber;
        data["capabilities"] = this.capabilities;
        return data;
    }
}

export interface ICollectorRegistrationRequestDto {
    collectorId: string;
    collectorVersion: string;
    serialNumber?: string | undefined;
    capabilities?: string | undefined;
}

export class CollectorHeartbeatRequestDto implements ICollectorHeartbeatRequestDto {
    collectorId!: string;
    collectorVersion!: string;

    constructor(data?: ICollectorHeartbeatRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.collectorId = _data["collectorId"];
            this.collectorVersion = _data["collectorVersion"];
        }
    }

    static fromJS(data: any): CollectorHeartbeatRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CollectorHeartbeatRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["collectorId"] = this.collectorId;
        data["collectorVersion"] = this.collectorVersion;
        return data;
    }
}

export interface ICollectorHeartbeatRequestDto {
    collectorId: string;
    collectorVersion: string;
}

export class IngestionAckDto implements IIngestionAckDto {
    accepted!: boolean;
    archiveIds!: string[];
    errors!: string[];

    constructor(data?: IIngestionAckDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.archiveIds = [];
            this.errors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accepted = _data["accepted"];
            if (Array.isArray(_data["archiveIds"])) {
                this.archiveIds = [] as any;
                for (let item of _data["archiveIds"])
                    this.archiveIds!.push(item);
            }
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
        }
    }

    static fromJS(data: any): IngestionAckDto {
        data = typeof data === 'object' ? data : {};
        let result = new IngestionAckDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accepted"] = this.accepted;
        if (Array.isArray(this.archiveIds)) {
            data["archiveIds"] = [];
            for (let item of this.archiveIds)
                data["archiveIds"].push(item);
        }
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data;
    }
}

export interface IIngestionAckDto {
    accepted: boolean;
    archiveIds: string[];
    errors: string[];
}

export class SignalAvailabilityReportRequestDto implements ISignalAvailabilityReportRequestDto {
    schemaVersion!: number;
    collectorId!: string;
    createdUtc!: number;
    samplingProfileId!: number;
    profileModifiedUtc!: DateTime;
    windowStartUtc!: number;
    signals!: SignalAvailabilityItemDto[];

    constructor(data?: ISignalAvailabilityReportRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.signals = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.schemaVersion = _data["schemaVersion"];
            this.collectorId = _data["collectorId"];
            this.createdUtc = _data["createdUtc"];
            this.samplingProfileId = _data["samplingProfileId"];
            this.profileModifiedUtc = _data["profileModifiedUtc"] ? DateTime.fromISO(_data["profileModifiedUtc"].toString()) : undefined as any;
            this.windowStartUtc = _data["windowStartUtc"];
            if (Array.isArray(_data["signals"])) {
                this.signals = [] as any;
                for (let item of _data["signals"])
                    this.signals!.push(SignalAvailabilityItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SignalAvailabilityReportRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new SignalAvailabilityReportRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["schemaVersion"] = this.schemaVersion;
        data["collectorId"] = this.collectorId;
        data["createdUtc"] = this.createdUtc;
        data["samplingProfileId"] = this.samplingProfileId;
        data["profileModifiedUtc"] = this.profileModifiedUtc ? this.profileModifiedUtc.toString() : undefined as any;
        data["windowStartUtc"] = this.windowStartUtc;
        if (Array.isArray(this.signals)) {
            data["signals"] = [];
            for (let item of this.signals)
                data["signals"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISignalAvailabilityReportRequestDto {
    schemaVersion: number;
    collectorId: string;
    createdUtc: number;
    samplingProfileId: number;
    profileModifiedUtc: DateTime;
    windowStartUtc: number;
    signals: SignalAvailabilityItemDto[];
}

export class SignalAvailabilityItemDto implements ISignalAvailabilityItemDto {
    signalId!: number;
    status!: SignalAvailabilityStatus;
    attemptCount!: number;
    successCount!: number;
    lastOkUtc?: number | undefined;
    lastFailureUtc?: number | undefined;
    detail?: string | undefined;

    constructor(data?: ISignalAvailabilityItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.signalId = _data["signalId"];
            this.status = _data["status"];
            this.attemptCount = _data["attemptCount"];
            this.successCount = _data["successCount"];
            this.lastOkUtc = _data["lastOkUtc"];
            this.lastFailureUtc = _data["lastFailureUtc"];
            this.detail = _data["detail"];
        }
    }

    static fromJS(data: any): SignalAvailabilityItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new SignalAvailabilityItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["signalId"] = this.signalId;
        data["status"] = this.status;
        data["attemptCount"] = this.attemptCount;
        data["successCount"] = this.successCount;
        data["lastOkUtc"] = this.lastOkUtc;
        data["lastFailureUtc"] = this.lastFailureUtc;
        data["detail"] = this.detail;
        return data;
    }
}

export interface ISignalAvailabilityItemDto {
    signalId: number;
    status: SignalAvailabilityStatus;
    attemptCount: number;
    successCount: number;
    lastOkUtc?: number | undefined;
    lastFailureUtc?: number | undefined;
    detail?: string | undefined;
}

export enum SignalAvailabilityStatus {
    Unknown = 0,
    Available = 1,
    NoResponse = 2,
    ParseError = 3,
    OutOfRange = 4,
    Intermittent = 5,
}

export class CollectorConfigurationDto implements ICollectorConfigurationDto {
    configurationVersion!: number;
    uploadIntervalMs!: number;
    samplingProfile?: SamplingProfileDto | undefined;
    updatedUtc!: DateTime;

    constructor(data?: ICollectorConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.configurationVersion = _data["configurationVersion"];
            this.uploadIntervalMs = _data["uploadIntervalMs"];
            this.samplingProfile = _data["samplingProfile"] ? SamplingProfileDto.fromJS(_data["samplingProfile"]) : undefined as any;
            this.updatedUtc = _data["updatedUtc"] ? DateTime.fromISO(_data["updatedUtc"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): CollectorConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CollectorConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["configurationVersion"] = this.configurationVersion;
        data["uploadIntervalMs"] = this.uploadIntervalMs;
        data["samplingProfile"] = this.samplingProfile ? this.samplingProfile.toJSON() : undefined as any;
        data["updatedUtc"] = this.updatedUtc ? this.updatedUtc.toString() : undefined as any;
        return data;
    }
}

export interface ICollectorConfigurationDto {
    configurationVersion: number;
    uploadIntervalMs: number;
    samplingProfile?: SamplingProfileDto | undefined;
    updatedUtc: DateTime;
}

export class SamplingProfileDto implements ISamplingProfileDto {
    id!: number;
    name!: string;
    description?: string | undefined;
    profileType!: SamplingProfileType;
    ownerUserId?: string | undefined;
    signals!: SamplingProfileSignalDto[];
    profileModifiedUtc!: DateTime;

    constructor(data?: ISamplingProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.signals = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.profileType = _data["profileType"];
            this.ownerUserId = _data["ownerUserId"];
            if (Array.isArray(_data["signals"])) {
                this.signals = [] as any;
                for (let item of _data["signals"])
                    this.signals!.push(SamplingProfileSignalDto.fromJS(item));
            }
            this.profileModifiedUtc = _data["profileModifiedUtc"] ? DateTime.fromISO(_data["profileModifiedUtc"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): SamplingProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new SamplingProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["profileType"] = this.profileType;
        data["ownerUserId"] = this.ownerUserId;
        if (Array.isArray(this.signals)) {
            data["signals"] = [];
            for (let item of this.signals)
                data["signals"].push(item ? item.toJSON() : undefined as any);
        }
        data["profileModifiedUtc"] = this.profileModifiedUtc ? this.profileModifiedUtc.toString() : undefined as any;
        return data;
    }
}

export interface ISamplingProfileDto {
    id: number;
    name: string;
    description?: string | undefined;
    profileType: SamplingProfileType;
    ownerUserId?: string | undefined;
    signals: SamplingProfileSignalDto[];
    profileModifiedUtc: DateTime;
}

export enum SamplingProfileType {
    System = 0,
    User = 1,
}

export class SamplingProfileSignalDto implements ISamplingProfileSignalDto {
    signalId!: number;
    enabled!: boolean;
    collectionMode!: SignalCollectionMode;
    samplingIntervalMs?: number | undefined;

    constructor(data?: ISamplingProfileSignalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.signalId = _data["signalId"];
            this.enabled = _data["enabled"];
            this.collectionMode = _data["collectionMode"];
            this.samplingIntervalMs = _data["samplingIntervalMs"];
        }
    }

    static fromJS(data: any): SamplingProfileSignalDto {
        data = typeof data === 'object' ? data : {};
        let result = new SamplingProfileSignalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["signalId"] = this.signalId;
        data["enabled"] = this.enabled;
        data["collectionMode"] = this.collectionMode;
        data["samplingIntervalMs"] = this.samplingIntervalMs;
        return data;
    }
}

export interface ISamplingProfileSignalDto {
    signalId: number;
    enabled: boolean;
    collectionMode: SignalCollectionMode;
    samplingIntervalMs?: number | undefined;
}

export enum SignalCollectionMode {
    Periodic = 0,
    OnChange = 1,
    Startup = 2,
    IgnitionOn = 3,
    IgnitionOff = 4,
}

export class RegisterDeviceInfoDTO implements IRegisterDeviceInfoDTO {
    deviceIdentifier!: string;
    devicePlatform!: MobilePlatform;
    fcmToken?: string | undefined;
    userId?: string | undefined;
    appVersion?: string | undefined;
    deviceVersion?: string | undefined;
    deviceModel?: string | undefined;
    deviceName?: string | undefined;
    language?: string | undefined;

    constructor(data?: IRegisterDeviceInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deviceIdentifier = _data["deviceIdentifier"];
            this.devicePlatform = _data["devicePlatform"];
            this.fcmToken = _data["fcmToken"];
            this.userId = _data["userId"];
            this.appVersion = _data["appVersion"];
            this.deviceVersion = _data["deviceVersion"];
            this.deviceModel = _data["deviceModel"];
            this.deviceName = _data["deviceName"];
            this.language = _data["language"];
        }
    }

    static fromJS(data: any): RegisterDeviceInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterDeviceInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceIdentifier"] = this.deviceIdentifier;
        data["devicePlatform"] = this.devicePlatform;
        data["fcmToken"] = this.fcmToken;
        data["userId"] = this.userId;
        data["appVersion"] = this.appVersion;
        data["deviceVersion"] = this.deviceVersion;
        data["deviceModel"] = this.deviceModel;
        data["deviceName"] = this.deviceName;
        data["language"] = this.language;
        return data;
    }
}

export interface IRegisterDeviceInfoDTO {
    deviceIdentifier: string;
    devicePlatform: MobilePlatform;
    fcmToken?: string | undefined;
    userId?: string | undefined;
    appVersion?: string | undefined;
    deviceVersion?: string | undefined;
    deviceModel?: string | undefined;
    deviceName?: string | undefined;
    language?: string | undefined;
}

export enum MobilePlatform {
    Android = 0,
    IOS = 1,
}

export class UnregisterDeviceInfoDTO implements IUnregisterDeviceInfoDTO {
    deviceIdentifier!: string;
    fcmToken?: string | undefined;

    constructor(data?: IUnregisterDeviceInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deviceIdentifier = _data["deviceIdentifier"];
            this.fcmToken = _data["fcmToken"];
        }
    }

    static fromJS(data: any): UnregisterDeviceInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UnregisterDeviceInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceIdentifier"] = this.deviceIdentifier;
        data["fcmToken"] = this.fcmToken;
        return data;
    }
}

export interface IUnregisterDeviceInfoDTO {
    deviceIdentifier: string;
    fcmToken?: string | undefined;
}

export class UpdateDevicePreferencesDTO implements IUpdateDevicePreferencesDTO {
    deviceIdentifier!: string;

    constructor(data?: IUpdateDevicePreferencesDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deviceIdentifier = _data["deviceIdentifier"];
        }
    }

    static fromJS(data: any): UpdateDevicePreferencesDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDevicePreferencesDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceIdentifier"] = this.deviceIdentifier;
        return data;
    }
}

export interface IUpdateDevicePreferencesDTO {
    deviceIdentifier: string;
}

export class SendPushNotificationDTO implements ISendPushNotificationDTO {
    token!: string;
    pushNotification!: PushNotificationDTO;
    isDataMessage!: boolean;
    channelId?: string | undefined;
    sound?: string | undefined;

    constructor(data?: ISendPushNotificationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.pushNotification = new PushNotificationDTO();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.pushNotification = _data["pushNotification"] ? PushNotificationDTO.fromJS(_data["pushNotification"]) : new PushNotificationDTO();
            this.isDataMessage = _data["isDataMessage"];
            this.channelId = _data["channelId"];
            this.sound = _data["sound"];
        }
    }

    static fromJS(data: any): SendPushNotificationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SendPushNotificationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["pushNotification"] = this.pushNotification ? this.pushNotification.toJSON() : undefined as any;
        data["isDataMessage"] = this.isDataMessage;
        data["channelId"] = this.channelId;
        data["sound"] = this.sound;
        return data;
    }
}

export interface ISendPushNotificationDTO {
    token: string;
    pushNotification: PushNotificationDTO;
    isDataMessage: boolean;
    channelId?: string | undefined;
    sound?: string | undefined;
}

export class PushNotificationDTO implements IPushNotificationDTO {
    title!: string;
    body!: string;
    type!: MessageType;
    parameters?: string[] | undefined;

    constructor(data?: IPushNotificationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.body = _data["body"];
            this.type = _data["type"];
            if (Array.isArray(_data["parameters"])) {
                this.parameters = [] as any;
                for (let item of _data["parameters"])
                    this.parameters!.push(item);
            }
        }
    }

    static fromJS(data: any): PushNotificationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PushNotificationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["body"] = this.body;
        data["type"] = this.type;
        if (Array.isArray(this.parameters)) {
            data["parameters"] = [];
            for (let item of this.parameters)
                data["parameters"].push(item);
        }
        return data;
    }
}

export interface IPushNotificationDTO {
    title: string;
    body: string;
    type: MessageType;
    parameters?: string[] | undefined;
}

export enum MessageType {
    Undefined = 0,
    Message = 1,
    Warning = 2,
    Reaction = 3,
    Alarm = 4,
}

export class PagedResultDTOOfSamplingProfileConfigDTO implements IPagedResultDTOOfSamplingProfileConfigDTO {
    items?: SamplingProfileConfigDTO[] | undefined;
    totalNumberOfItems!: number;

    constructor(data?: IPagedResultDTOOfSamplingProfileConfigDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SamplingProfileConfigDTO.fromJS(item));
            }
            this.totalNumberOfItems = _data["totalNumberOfItems"];
        }
    }

    static fromJS(data: any): PagedResultDTOOfSamplingProfileConfigDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDTOOfSamplingProfileConfigDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalNumberOfItems"] = this.totalNumberOfItems;
        return data;
    }
}

export interface IPagedResultDTOOfSamplingProfileConfigDTO {
    items?: SamplingProfileConfigDTO[] | undefined;
    totalNumberOfItems: number;
}

export class SamplingProfileConfigDTO implements ISamplingProfileConfigDTO {
    id!: number;
    name?: string | undefined;
    description?: string | undefined;
    profileType!: SamplingProfileType;
    ownerUserId?: string | undefined;
    ownerUserName?: string | undefined;
    profileModifiedUtc!: DateTime;
    signalCount!: number;
    vehicleCount!: number;
    signals!: SamplingProfileSignalConfigDTO[];

    constructor(data?: ISamplingProfileConfigDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.signals = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.profileType = _data["profileType"];
            this.ownerUserId = _data["ownerUserId"];
            this.ownerUserName = _data["ownerUserName"];
            this.profileModifiedUtc = _data["profileModifiedUtc"] ? DateTime.fromISO(_data["profileModifiedUtc"].toString()) : undefined as any;
            this.signalCount = _data["signalCount"];
            this.vehicleCount = _data["vehicleCount"];
            if (Array.isArray(_data["signals"])) {
                this.signals = [] as any;
                for (let item of _data["signals"])
                    this.signals!.push(SamplingProfileSignalConfigDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SamplingProfileConfigDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SamplingProfileConfigDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["profileType"] = this.profileType;
        data["ownerUserId"] = this.ownerUserId;
        data["ownerUserName"] = this.ownerUserName;
        data["profileModifiedUtc"] = this.profileModifiedUtc ? this.profileModifiedUtc.toString() : undefined as any;
        data["signalCount"] = this.signalCount;
        data["vehicleCount"] = this.vehicleCount;
        if (Array.isArray(this.signals)) {
            data["signals"] = [];
            for (let item of this.signals)
                data["signals"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISamplingProfileConfigDTO {
    id: number;
    name?: string | undefined;
    description?: string | undefined;
    profileType: SamplingProfileType;
    ownerUserId?: string | undefined;
    ownerUserName?: string | undefined;
    profileModifiedUtc: DateTime;
    signalCount: number;
    vehicleCount: number;
    signals: SamplingProfileSignalConfigDTO[];
}

export class SamplingProfileSignalConfigDTO implements ISamplingProfileSignalConfigDTO {
    id!: number;
    signalId!: number;
    signalName?: string | undefined;
    displayName?: string | undefined;
    category?: string | undefined;
    unit?: string | undefined;
    enabled!: boolean;
    collectionMode!: SignalCollectionMode;
    samplingIntervalMs?: number | undefined;

    constructor(data?: ISamplingProfileSignalConfigDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.signalId = _data["signalId"];
            this.signalName = _data["signalName"];
            this.displayName = _data["displayName"];
            this.category = _data["category"];
            this.unit = _data["unit"];
            this.enabled = _data["enabled"];
            this.collectionMode = _data["collectionMode"];
            this.samplingIntervalMs = _data["samplingIntervalMs"];
        }
    }

    static fromJS(data: any): SamplingProfileSignalConfigDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SamplingProfileSignalConfigDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["signalId"] = this.signalId;
        data["signalName"] = this.signalName;
        data["displayName"] = this.displayName;
        data["category"] = this.category;
        data["unit"] = this.unit;
        data["enabled"] = this.enabled;
        data["collectionMode"] = this.collectionMode;
        data["samplingIntervalMs"] = this.samplingIntervalMs;
        return data;
    }
}

export interface ISamplingProfileSignalConfigDTO {
    id: number;
    signalId: number;
    signalName?: string | undefined;
    displayName?: string | undefined;
    category?: string | undefined;
    unit?: string | undefined;
    enabled: boolean;
    collectionMode: SignalCollectionMode;
    samplingIntervalMs?: number | undefined;
}

export class CreateSamplingProfileConfigDTO implements ICreateSamplingProfileConfigDTO {
    name!: string;
    description?: string | undefined;
    profileType!: SamplingProfileType;
    signals!: SamplingProfileSignalConfigDTO[];

    constructor(data?: ICreateSamplingProfileConfigDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.signals = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.profileType = _data["profileType"];
            if (Array.isArray(_data["signals"])) {
                this.signals = [] as any;
                for (let item of _data["signals"])
                    this.signals!.push(SamplingProfileSignalConfigDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateSamplingProfileConfigDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSamplingProfileConfigDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["profileType"] = this.profileType;
        if (Array.isArray(this.signals)) {
            data["signals"] = [];
            for (let item of this.signals)
                data["signals"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICreateSamplingProfileConfigDTO {
    name: string;
    description?: string | undefined;
    profileType: SamplingProfileType;
    signals: SamplingProfileSignalConfigDTO[];
}

export class UpdateSamplingProfileConfigDTO implements IUpdateSamplingProfileConfigDTO {
    id!: number;
    name!: string;
    description?: string | undefined;
    signals!: SamplingProfileSignalConfigDTO[];

    constructor(data?: IUpdateSamplingProfileConfigDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.signals = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            if (Array.isArray(_data["signals"])) {
                this.signals = [] as any;
                for (let item of _data["signals"])
                    this.signals!.push(SamplingProfileSignalConfigDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateSamplingProfileConfigDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSamplingProfileConfigDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        if (Array.isArray(this.signals)) {
            data["signals"] = [];
            for (let item of this.signals)
                data["signals"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUpdateSamplingProfileConfigDTO {
    id: number;
    name: string;
    description?: string | undefined;
    signals: SamplingProfileSignalConfigDTO[];
}

export class AssignSamplingProfileDTO implements IAssignSamplingProfileDTO {
    vehicleId!: number;
    samplingProfileId!: number;

    constructor(data?: IAssignSamplingProfileDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicleId = _data["vehicleId"];
            this.samplingProfileId = _data["samplingProfileId"];
        }
    }

    static fromJS(data: any): AssignSamplingProfileDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AssignSamplingProfileDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vehicleId"] = this.vehicleId;
        data["samplingProfileId"] = this.samplingProfileId;
        return data;
    }
}

export interface IAssignSamplingProfileDTO {
    vehicleId: number;
    samplingProfileId: number;
}

export class VehicleListDTO implements IVehicleListDTO {
    id!: number;
    vehicleUuid!: string;
    vin?: string | undefined;
    manufacturer?: string | undefined;
    brand?: string | undefined;
    model?: string | undefined;
    modelYear?: number | undefined;
    samplingProfileId?: number | undefined;
    samplingProfileName?: string | undefined;

    constructor(data?: IVehicleListDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.vehicleUuid = _data["vehicleUuid"];
            this.vin = _data["vin"];
            this.manufacturer = _data["manufacturer"];
            this.brand = _data["brand"];
            this.model = _data["model"];
            this.modelYear = _data["modelYear"];
            this.samplingProfileId = _data["samplingProfileId"];
            this.samplingProfileName = _data["samplingProfileName"];
        }
    }

    static fromJS(data: any): VehicleListDTO {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleListDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["vehicleUuid"] = this.vehicleUuid;
        data["vin"] = this.vin;
        data["manufacturer"] = this.manufacturer;
        data["brand"] = this.brand;
        data["model"] = this.model;
        data["modelYear"] = this.modelYear;
        data["samplingProfileId"] = this.samplingProfileId;
        data["samplingProfileName"] = this.samplingProfileName;
        return data;
    }
}

export interface IVehicleListDTO {
    id: number;
    vehicleUuid: string;
    vin?: string | undefined;
    manufacturer?: string | undefined;
    brand?: string | undefined;
    model?: string | undefined;
    modelYear?: number | undefined;
    samplingProfileId?: number | undefined;
    samplingProfileName?: string | undefined;
}

export class VehicleSignalAvailabilityDTO implements IVehicleSignalAvailabilityDTO {
    vehicleId!: number;
    vehicleUuid!: string;
    vin?: string | undefined;
    samplingProfileId?: number | undefined;
    samplingProfileName?: string | undefined;
    profileModifiedUtc?: DateTime | undefined;
    hasActiveInstallation!: boolean;
    collectorVehicleId?: number | undefined;
    collectorId?: string | undefined;
    lastReportUtc?: DateTime | undefined;
    configuredSignalCount!: number;
    availableCount!: number;
    unavailableCount!: number;
    intermittentCount!: number;
    unknownCount!: number;
    staleCount!: number;
    signals!: SignalAvailabilityDTO[];

    constructor(data?: IVehicleSignalAvailabilityDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.signals = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicleId = _data["vehicleId"];
            this.vehicleUuid = _data["vehicleUuid"];
            this.vin = _data["vin"];
            this.samplingProfileId = _data["samplingProfileId"];
            this.samplingProfileName = _data["samplingProfileName"];
            this.profileModifiedUtc = _data["profileModifiedUtc"] ? DateTime.fromISO(_data["profileModifiedUtc"].toString()) : undefined as any;
            this.hasActiveInstallation = _data["hasActiveInstallation"];
            this.collectorVehicleId = _data["collectorVehicleId"];
            this.collectorId = _data["collectorId"];
            this.lastReportUtc = _data["lastReportUtc"] ? DateTime.fromISO(_data["lastReportUtc"].toString()) : undefined as any;
            this.configuredSignalCount = _data["configuredSignalCount"];
            this.availableCount = _data["availableCount"];
            this.unavailableCount = _data["unavailableCount"];
            this.intermittentCount = _data["intermittentCount"];
            this.unknownCount = _data["unknownCount"];
            this.staleCount = _data["staleCount"];
            if (Array.isArray(_data["signals"])) {
                this.signals = [] as any;
                for (let item of _data["signals"])
                    this.signals!.push(SignalAvailabilityDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VehicleSignalAvailabilityDTO {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleSignalAvailabilityDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vehicleId"] = this.vehicleId;
        data["vehicleUuid"] = this.vehicleUuid;
        data["vin"] = this.vin;
        data["samplingProfileId"] = this.samplingProfileId;
        data["samplingProfileName"] = this.samplingProfileName;
        data["profileModifiedUtc"] = this.profileModifiedUtc ? this.profileModifiedUtc.toString() : undefined as any;
        data["hasActiveInstallation"] = this.hasActiveInstallation;
        data["collectorVehicleId"] = this.collectorVehicleId;
        data["collectorId"] = this.collectorId;
        data["lastReportUtc"] = this.lastReportUtc ? this.lastReportUtc.toString() : undefined as any;
        data["configuredSignalCount"] = this.configuredSignalCount;
        data["availableCount"] = this.availableCount;
        data["unavailableCount"] = this.unavailableCount;
        data["intermittentCount"] = this.intermittentCount;
        data["unknownCount"] = this.unknownCount;
        data["staleCount"] = this.staleCount;
        if (Array.isArray(this.signals)) {
            data["signals"] = [];
            for (let item of this.signals)
                data["signals"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IVehicleSignalAvailabilityDTO {
    vehicleId: number;
    vehicleUuid: string;
    vin?: string | undefined;
    samplingProfileId?: number | undefined;
    samplingProfileName?: string | undefined;
    profileModifiedUtc?: DateTime | undefined;
    hasActiveInstallation: boolean;
    collectorVehicleId?: number | undefined;
    collectorId?: string | undefined;
    lastReportUtc?: DateTime | undefined;
    configuredSignalCount: number;
    availableCount: number;
    unavailableCount: number;
    intermittentCount: number;
    unknownCount: number;
    staleCount: number;
    signals: SignalAvailabilityDTO[];
}

export class SignalAvailabilityDTO implements ISignalAvailabilityDTO {
    signalId!: number;
    signalName?: string | undefined;
    displayName?: string | undefined;
    category?: string | undefined;
    unit?: string | undefined;
    enabled!: boolean;
    collectionMode!: SignalCollectionMode;
    samplingIntervalMs?: number | undefined;
    status!: SignalAvailabilityStatus;
    neverReported!: boolean;
    isStale!: boolean;
    attemptCount!: number;
    successCount!: number;
    successRate?: number | undefined;
    lastOkUtc?: DateTime | undefined;
    lastFailureUtc?: DateTime | undefined;
    lastEvaluatedUtc?: DateTime | undefined;
    evaluatedAgainstProfileModifiedUtc?: DateTime | undefined;
    detail?: string | undefined;

    constructor(data?: ISignalAvailabilityDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.signalId = _data["signalId"];
            this.signalName = _data["signalName"];
            this.displayName = _data["displayName"];
            this.category = _data["category"];
            this.unit = _data["unit"];
            this.enabled = _data["enabled"];
            this.collectionMode = _data["collectionMode"];
            this.samplingIntervalMs = _data["samplingIntervalMs"];
            this.status = _data["status"];
            this.neverReported = _data["neverReported"];
            this.isStale = _data["isStale"];
            this.attemptCount = _data["attemptCount"];
            this.successCount = _data["successCount"];
            this.successRate = _data["successRate"];
            this.lastOkUtc = _data["lastOkUtc"] ? DateTime.fromISO(_data["lastOkUtc"].toString()) : undefined as any;
            this.lastFailureUtc = _data["lastFailureUtc"] ? DateTime.fromISO(_data["lastFailureUtc"].toString()) : undefined as any;
            this.lastEvaluatedUtc = _data["lastEvaluatedUtc"] ? DateTime.fromISO(_data["lastEvaluatedUtc"].toString()) : undefined as any;
            this.evaluatedAgainstProfileModifiedUtc = _data["evaluatedAgainstProfileModifiedUtc"] ? DateTime.fromISO(_data["evaluatedAgainstProfileModifiedUtc"].toString()) : undefined as any;
            this.detail = _data["detail"];
        }
    }

    static fromJS(data: any): SignalAvailabilityDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SignalAvailabilityDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["signalId"] = this.signalId;
        data["signalName"] = this.signalName;
        data["displayName"] = this.displayName;
        data["category"] = this.category;
        data["unit"] = this.unit;
        data["enabled"] = this.enabled;
        data["collectionMode"] = this.collectionMode;
        data["samplingIntervalMs"] = this.samplingIntervalMs;
        data["status"] = this.status;
        data["neverReported"] = this.neverReported;
        data["isStale"] = this.isStale;
        data["attemptCount"] = this.attemptCount;
        data["successCount"] = this.successCount;
        data["successRate"] = this.successRate;
        data["lastOkUtc"] = this.lastOkUtc ? this.lastOkUtc.toString() : undefined as any;
        data["lastFailureUtc"] = this.lastFailureUtc ? this.lastFailureUtc.toString() : undefined as any;
        data["lastEvaluatedUtc"] = this.lastEvaluatedUtc ? this.lastEvaluatedUtc.toString() : undefined as any;
        data["evaluatedAgainstProfileModifiedUtc"] = this.evaluatedAgainstProfileModifiedUtc ? this.evaluatedAgainstProfileModifiedUtc.toString() : undefined as any;
        data["detail"] = this.detail;
        return data;
    }
}

export interface ISignalAvailabilityDTO {
    signalId: number;
    signalName?: string | undefined;
    displayName?: string | undefined;
    category?: string | undefined;
    unit?: string | undefined;
    enabled: boolean;
    collectionMode: SignalCollectionMode;
    samplingIntervalMs?: number | undefined;
    status: SignalAvailabilityStatus;
    neverReported: boolean;
    isStale: boolean;
    attemptCount: number;
    successCount: number;
    successRate?: number | undefined;
    lastOkUtc?: DateTime | undefined;
    lastFailureUtc?: DateTime | undefined;
    lastEvaluatedUtc?: DateTime | undefined;
    evaluatedAgainstProfileModifiedUtc?: DateTime | undefined;
    detail?: string | undefined;
}

export class SignalCatalogDto implements ISignalCatalogDto {
    signals!: SignalDefinitionDto[];
    mappings!: SignalMappingDto[];

    constructor(data?: ISignalCatalogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.signals = [];
            this.mappings = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["signals"])) {
                this.signals = [] as any;
                for (let item of _data["signals"])
                    this.signals!.push(SignalDefinitionDto.fromJS(item));
            }
            if (Array.isArray(_data["mappings"])) {
                this.mappings = [] as any;
                for (let item of _data["mappings"])
                    this.mappings!.push(SignalMappingDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SignalCatalogDto {
        data = typeof data === 'object' ? data : {};
        let result = new SignalCatalogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.signals)) {
            data["signals"] = [];
            for (let item of this.signals)
                data["signals"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.mappings)) {
            data["mappings"] = [];
            for (let item of this.mappings)
                data["mappings"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISignalCatalogDto {
    signals: SignalDefinitionDto[];
    mappings: SignalMappingDto[];
}

export class SignalDefinitionDto implements ISignalDefinitionDto {
    signalId!: number;
    name!: string;
    displayName?: string | undefined;
    category?: string | undefined;
    description?: string | undefined;
    unit?: string | undefined;
    dataType?: string | undefined;

    constructor(data?: ISignalDefinitionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.signalId = _data["signalId"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.category = _data["category"];
            this.description = _data["description"];
            this.unit = _data["unit"];
            this.dataType = _data["dataType"];
        }
    }

    static fromJS(data: any): SignalDefinitionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SignalDefinitionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["signalId"] = this.signalId;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["category"] = this.category;
        data["description"] = this.description;
        data["unit"] = this.unit;
        data["dataType"] = this.dataType;
        return data;
    }
}

export interface ISignalDefinitionDto {
    signalId: number;
    name: string;
    displayName?: string | undefined;
    category?: string | undefined;
    description?: string | undefined;
    unit?: string | undefined;
    dataType?: string | undefined;
}

export class SignalMappingDto implements ISignalMappingDto {
    mappingId!: number;
    signalId!: number;
    protocol!: string;
    identifier!: string;
    subIdentifier?: string | undefined;
    sourceEcu?: string | undefined;
    scaling!: number;
    offset!: number;
    minimum!: number;
    maximum!: number;
    resolution!: number;
    isSigned!: boolean;
    byteCount!: number;

    constructor(data?: ISignalMappingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mappingId = _data["mappingId"];
            this.signalId = _data["signalId"];
            this.protocol = _data["protocol"];
            this.identifier = _data["identifier"];
            this.subIdentifier = _data["subIdentifier"];
            this.sourceEcu = _data["sourceEcu"];
            this.scaling = _data["scaling"];
            this.offset = _data["offset"];
            this.minimum = _data["minimum"];
            this.maximum = _data["maximum"];
            this.resolution = _data["resolution"];
            this.isSigned = _data["isSigned"];
            this.byteCount = _data["byteCount"];
        }
    }

    static fromJS(data: any): SignalMappingDto {
        data = typeof data === 'object' ? data : {};
        let result = new SignalMappingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mappingId"] = this.mappingId;
        data["signalId"] = this.signalId;
        data["protocol"] = this.protocol;
        data["identifier"] = this.identifier;
        data["subIdentifier"] = this.subIdentifier;
        data["sourceEcu"] = this.sourceEcu;
        data["scaling"] = this.scaling;
        data["offset"] = this.offset;
        data["minimum"] = this.minimum;
        data["maximum"] = this.maximum;
        data["resolution"] = this.resolution;
        data["isSigned"] = this.isSigned;
        data["byteCount"] = this.byteCount;
        return data;
    }
}

export interface ISignalMappingDto {
    mappingId: number;
    signalId: number;
    protocol: string;
    identifier: string;
    subIdentifier?: string | undefined;
    sourceEcu?: string | undefined;
    scaling: number;
    offset: number;
    minimum: number;
    maximum: number;
    resolution: number;
    isSigned: boolean;
    byteCount: number;
}

export class PagedResultDTOOfSignalDefinitionConfigDTO implements IPagedResultDTOOfSignalDefinitionConfigDTO {
    items?: SignalDefinitionConfigDTO[] | undefined;
    totalNumberOfItems!: number;

    constructor(data?: IPagedResultDTOOfSignalDefinitionConfigDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SignalDefinitionConfigDTO.fromJS(item));
            }
            this.totalNumberOfItems = _data["totalNumberOfItems"];
        }
    }

    static fromJS(data: any): PagedResultDTOOfSignalDefinitionConfigDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDTOOfSignalDefinitionConfigDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalNumberOfItems"] = this.totalNumberOfItems;
        return data;
    }
}

export interface IPagedResultDTOOfSignalDefinitionConfigDTO {
    items?: SignalDefinitionConfigDTO[] | undefined;
    totalNumberOfItems: number;
}

export class SignalDefinitionConfigDTO implements ISignalDefinitionConfigDTO {
    id!: number;
    signalId!: number;
    name?: string | undefined;
    displayName?: string | undefined;
    category?: string | undefined;
    description?: string | undefined;
    unit?: string | undefined;
    dataType?: string | undefined;

    constructor(data?: ISignalDefinitionConfigDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.signalId = _data["signalId"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.category = _data["category"];
            this.description = _data["description"];
            this.unit = _data["unit"];
            this.dataType = _data["dataType"];
        }
    }

    static fromJS(data: any): SignalDefinitionConfigDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SignalDefinitionConfigDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["signalId"] = this.signalId;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["category"] = this.category;
        data["description"] = this.description;
        data["unit"] = this.unit;
        data["dataType"] = this.dataType;
        return data;
    }
}

export interface ISignalDefinitionConfigDTO {
    id: number;
    signalId: number;
    name?: string | undefined;
    displayName?: string | undefined;
    category?: string | undefined;
    description?: string | undefined;
    unit?: string | undefined;
    dataType?: string | undefined;
}

export class VehicleRunningTotalDTO implements IVehicleRunningTotalDTO {
    statisticName!: string;
    moduleName!: string;
    valueJson?: string | undefined;
    updatedUtc!: DateTime;

    constructor(data?: IVehicleRunningTotalDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statisticName = _data["statisticName"];
            this.moduleName = _data["moduleName"];
            this.valueJson = _data["valueJson"];
            this.updatedUtc = _data["updatedUtc"] ? DateTime.fromISO(_data["updatedUtc"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): VehicleRunningTotalDTO {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleRunningTotalDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statisticName"] = this.statisticName;
        data["moduleName"] = this.moduleName;
        data["valueJson"] = this.valueJson;
        data["updatedUtc"] = this.updatedUtc ? this.updatedUtc.toString() : undefined as any;
        return data;
    }
}

export interface IVehicleRunningTotalDTO {
    statisticName: string;
    moduleName: string;
    valueJson?: string | undefined;
    updatedUtc: DateTime;
}

export class PagedResultDTOOfTripDTO implements IPagedResultDTOOfTripDTO {
    items?: TripDTO[] | undefined;
    totalNumberOfItems!: number;

    constructor(data?: IPagedResultDTOOfTripDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TripDTO.fromJS(item));
            }
            this.totalNumberOfItems = _data["totalNumberOfItems"];
        }
    }

    static fromJS(data: any): PagedResultDTOOfTripDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDTOOfTripDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalNumberOfItems"] = this.totalNumberOfItems;
        return data;
    }
}

export interface IPagedResultDTOOfTripDTO {
    items?: TripDTO[] | undefined;
    totalNumberOfItems: number;
}

export class TripDTO implements ITripDTO {
    id!: number;
    vehicleId!: number;
    startUtc!: DateTime;
    endUtc?: DateTime | undefined;
    status!: TripStatus;
    closedReason?: TripClosedReason | undefined;
    accumulatedDistanceKm!: number;
    accumulatedFuelUsedL!: number;
    accumulatedRuntimeMin!: number;

    constructor(data?: ITripDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.vehicleId = _data["vehicleId"];
            this.startUtc = _data["startUtc"] ? DateTime.fromISO(_data["startUtc"].toString()) : undefined as any;
            this.endUtc = _data["endUtc"] ? DateTime.fromISO(_data["endUtc"].toString()) : undefined as any;
            this.status = _data["status"];
            this.closedReason = _data["closedReason"];
            this.accumulatedDistanceKm = _data["accumulatedDistanceKm"];
            this.accumulatedFuelUsedL = _data["accumulatedFuelUsedL"];
            this.accumulatedRuntimeMin = _data["accumulatedRuntimeMin"];
        }
    }

    static fromJS(data: any): TripDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TripDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["vehicleId"] = this.vehicleId;
        data["startUtc"] = this.startUtc ? this.startUtc.toString() : undefined as any;
        data["endUtc"] = this.endUtc ? this.endUtc.toString() : undefined as any;
        data["status"] = this.status;
        data["closedReason"] = this.closedReason;
        data["accumulatedDistanceKm"] = this.accumulatedDistanceKm;
        data["accumulatedFuelUsedL"] = this.accumulatedFuelUsedL;
        data["accumulatedRuntimeMin"] = this.accumulatedRuntimeMin;
        return data;
    }
}

export interface ITripDTO {
    id: number;
    vehicleId: number;
    startUtc: DateTime;
    endUtc?: DateTime | undefined;
    status: TripStatus;
    closedReason?: TripClosedReason | undefined;
    accumulatedDistanceKm: number;
    accumulatedFuelUsedL: number;
    accumulatedRuntimeMin: number;
}

export enum TripStatus {
    Open = 0,
    PendingEndOfTrip = 1,
    Closed = 2,
}

export enum TripClosedReason {
    StationaryTimeout = 0,
    ParkingBrakeEngaged = 1,
    TransmissionPark = 2,
    DataGap = 3,
    TelemetryStopped = 4,
}

export class TripDetailDTO extends TripDTO implements ITripDetailDTO {
    averageSpeedKmh?: StatValueOfNullableDouble | undefined;
    maximumSpeedKmh?: StatValueOfNullableDouble | undefined;
    drivingTimeMin?: StatValueOfNullableDouble | undefined;
    averageFuelConsumptionL100km?: StatValueOfNullableDouble | undefined;
    fuelEfficiencyKmPerL?: StatValueOfNullableDouble | undefined;
    idleTimeMin?: StatValueOfNullableDouble | undefined;
    engineWarmUpTimeMin?: StatValueOfNullableDouble | undefined;
    coldStart?: StatValueOfNullableBoolean | undefined;
    tripClassification?: StatValueOfString | undefined;
    isShortTrip?: StatValueOfNullableBoolean | undefined;
    driverScore?: StatValueOfNullableDouble | undefined;
    harshBrakingCount?: StatValueOfNullableInteger | undefined;
    harshAccelerationCount?: StatValueOfNullableInteger | undefined;
    aggressiveCorneringCount?: StatValueOfNullableInteger | undefined;
    speedingCount?: StatValueOfNullableInteger | undefined;
    engineLoadMinPercent?: StatValueOfNullableDouble | undefined;
    engineLoadMaxPercent?: StatValueOfNullableDouble | undefined;
    engineLoadAvgPercent?: StatValueOfNullableDouble | undefined;
    engineLoadHistogram?: StatValueOfListOfEngineLoadBucketDTO | undefined;
    statistics!: TripStatisticDTO[];

    constructor(data?: ITripDetailDTO) {
        super(data);
        if (!data) {
            this.statistics = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.averageSpeedKmh = _data["averageSpeedKmh"] ? StatValueOfNullableDouble.fromJS(_data["averageSpeedKmh"]) : undefined as any;
            this.maximumSpeedKmh = _data["maximumSpeedKmh"] ? StatValueOfNullableDouble.fromJS(_data["maximumSpeedKmh"]) : undefined as any;
            this.drivingTimeMin = _data["drivingTimeMin"] ? StatValueOfNullableDouble.fromJS(_data["drivingTimeMin"]) : undefined as any;
            this.averageFuelConsumptionL100km = _data["averageFuelConsumptionL100km"] ? StatValueOfNullableDouble.fromJS(_data["averageFuelConsumptionL100km"]) : undefined as any;
            this.fuelEfficiencyKmPerL = _data["fuelEfficiencyKmPerL"] ? StatValueOfNullableDouble.fromJS(_data["fuelEfficiencyKmPerL"]) : undefined as any;
            this.idleTimeMin = _data["idleTimeMin"] ? StatValueOfNullableDouble.fromJS(_data["idleTimeMin"]) : undefined as any;
            this.engineWarmUpTimeMin = _data["engineWarmUpTimeMin"] ? StatValueOfNullableDouble.fromJS(_data["engineWarmUpTimeMin"]) : undefined as any;
            this.coldStart = _data["coldStart"] ? StatValueOfNullableBoolean.fromJS(_data["coldStart"]) : undefined as any;
            this.tripClassification = _data["tripClassification"] ? StatValueOfString.fromJS(_data["tripClassification"]) : undefined as any;
            this.isShortTrip = _data["isShortTrip"] ? StatValueOfNullableBoolean.fromJS(_data["isShortTrip"]) : undefined as any;
            this.driverScore = _data["driverScore"] ? StatValueOfNullableDouble.fromJS(_data["driverScore"]) : undefined as any;
            this.harshBrakingCount = _data["harshBrakingCount"] ? StatValueOfNullableInteger.fromJS(_data["harshBrakingCount"]) : undefined as any;
            this.harshAccelerationCount = _data["harshAccelerationCount"] ? StatValueOfNullableInteger.fromJS(_data["harshAccelerationCount"]) : undefined as any;
            this.aggressiveCorneringCount = _data["aggressiveCorneringCount"] ? StatValueOfNullableInteger.fromJS(_data["aggressiveCorneringCount"]) : undefined as any;
            this.speedingCount = _data["speedingCount"] ? StatValueOfNullableInteger.fromJS(_data["speedingCount"]) : undefined as any;
            this.engineLoadMinPercent = _data["engineLoadMinPercent"] ? StatValueOfNullableDouble.fromJS(_data["engineLoadMinPercent"]) : undefined as any;
            this.engineLoadMaxPercent = _data["engineLoadMaxPercent"] ? StatValueOfNullableDouble.fromJS(_data["engineLoadMaxPercent"]) : undefined as any;
            this.engineLoadAvgPercent = _data["engineLoadAvgPercent"] ? StatValueOfNullableDouble.fromJS(_data["engineLoadAvgPercent"]) : undefined as any;
            this.engineLoadHistogram = _data["engineLoadHistogram"] ? StatValueOfListOfEngineLoadBucketDTO.fromJS(_data["engineLoadHistogram"]) : undefined as any;
            if (Array.isArray(_data["statistics"])) {
                this.statistics = [] as any;
                for (let item of _data["statistics"])
                    this.statistics!.push(TripStatisticDTO.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): TripDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TripDetailDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["averageSpeedKmh"] = this.averageSpeedKmh ? this.averageSpeedKmh.toJSON() : undefined as any;
        data["maximumSpeedKmh"] = this.maximumSpeedKmh ? this.maximumSpeedKmh.toJSON() : undefined as any;
        data["drivingTimeMin"] = this.drivingTimeMin ? this.drivingTimeMin.toJSON() : undefined as any;
        data["averageFuelConsumptionL100km"] = this.averageFuelConsumptionL100km ? this.averageFuelConsumptionL100km.toJSON() : undefined as any;
        data["fuelEfficiencyKmPerL"] = this.fuelEfficiencyKmPerL ? this.fuelEfficiencyKmPerL.toJSON() : undefined as any;
        data["idleTimeMin"] = this.idleTimeMin ? this.idleTimeMin.toJSON() : undefined as any;
        data["engineWarmUpTimeMin"] = this.engineWarmUpTimeMin ? this.engineWarmUpTimeMin.toJSON() : undefined as any;
        data["coldStart"] = this.coldStart ? this.coldStart.toJSON() : undefined as any;
        data["tripClassification"] = this.tripClassification ? this.tripClassification.toJSON() : undefined as any;
        data["isShortTrip"] = this.isShortTrip ? this.isShortTrip.toJSON() : undefined as any;
        data["driverScore"] = this.driverScore ? this.driverScore.toJSON() : undefined as any;
        data["harshBrakingCount"] = this.harshBrakingCount ? this.harshBrakingCount.toJSON() : undefined as any;
        data["harshAccelerationCount"] = this.harshAccelerationCount ? this.harshAccelerationCount.toJSON() : undefined as any;
        data["aggressiveCorneringCount"] = this.aggressiveCorneringCount ? this.aggressiveCorneringCount.toJSON() : undefined as any;
        data["speedingCount"] = this.speedingCount ? this.speedingCount.toJSON() : undefined as any;
        data["engineLoadMinPercent"] = this.engineLoadMinPercent ? this.engineLoadMinPercent.toJSON() : undefined as any;
        data["engineLoadMaxPercent"] = this.engineLoadMaxPercent ? this.engineLoadMaxPercent.toJSON() : undefined as any;
        data["engineLoadAvgPercent"] = this.engineLoadAvgPercent ? this.engineLoadAvgPercent.toJSON() : undefined as any;
        data["engineLoadHistogram"] = this.engineLoadHistogram ? this.engineLoadHistogram.toJSON() : undefined as any;
        if (Array.isArray(this.statistics)) {
            data["statistics"] = [];
            for (let item of this.statistics)
                data["statistics"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ITripDetailDTO extends ITripDTO {
    averageSpeedKmh?: StatValueOfNullableDouble | undefined;
    maximumSpeedKmh?: StatValueOfNullableDouble | undefined;
    drivingTimeMin?: StatValueOfNullableDouble | undefined;
    averageFuelConsumptionL100km?: StatValueOfNullableDouble | undefined;
    fuelEfficiencyKmPerL?: StatValueOfNullableDouble | undefined;
    idleTimeMin?: StatValueOfNullableDouble | undefined;
    engineWarmUpTimeMin?: StatValueOfNullableDouble | undefined;
    coldStart?: StatValueOfNullableBoolean | undefined;
    tripClassification?: StatValueOfString | undefined;
    isShortTrip?: StatValueOfNullableBoolean | undefined;
    driverScore?: StatValueOfNullableDouble | undefined;
    harshBrakingCount?: StatValueOfNullableInteger | undefined;
    harshAccelerationCount?: StatValueOfNullableInteger | undefined;
    aggressiveCorneringCount?: StatValueOfNullableInteger | undefined;
    speedingCount?: StatValueOfNullableInteger | undefined;
    engineLoadMinPercent?: StatValueOfNullableDouble | undefined;
    engineLoadMaxPercent?: StatValueOfNullableDouble | undefined;
    engineLoadAvgPercent?: StatValueOfNullableDouble | undefined;
    engineLoadHistogram?: StatValueOfListOfEngineLoadBucketDTO | undefined;
    statistics: TripStatisticDTO[];
}

export class StatValueOfNullableDouble implements IStatValueOfNullableDouble {
    value?: number | undefined;
    status!: StatisticStatus;
    reasons?: UnavailableReason[] | undefined;

    constructor(data?: IStatValueOfNullableDouble) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.status = _data["status"];
            if (Array.isArray(_data["reasons"])) {
                this.reasons = [] as any;
                for (let item of _data["reasons"])
                    this.reasons!.push(UnavailableReason.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StatValueOfNullableDouble {
        data = typeof data === 'object' ? data : {};
        let result = new StatValueOfNullableDouble();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["status"] = this.status;
        if (Array.isArray(this.reasons)) {
            data["reasons"] = [];
            for (let item of this.reasons)
                data["reasons"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IStatValueOfNullableDouble {
    value?: number | undefined;
    status: StatisticStatus;
    reasons?: UnavailableReason[] | undefined;
}

export enum StatisticStatus {
    Calculated = 0,
    Unavailable = 1,
}

export class UnavailableReason implements IUnavailableReason {
    signalIds!: number[];
    reason!: string;
    detail?: string | undefined;

    constructor(data?: IUnavailableReason) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.signalIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["signalIds"])) {
                this.signalIds = [] as any;
                for (let item of _data["signalIds"])
                    this.signalIds!.push(item);
            }
            this.reason = _data["reason"];
            this.detail = _data["detail"];
        }
    }

    static fromJS(data: any): UnavailableReason {
        data = typeof data === 'object' ? data : {};
        let result = new UnavailableReason();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.signalIds)) {
            data["signalIds"] = [];
            for (let item of this.signalIds)
                data["signalIds"].push(item);
        }
        data["reason"] = this.reason;
        data["detail"] = this.detail;
        return data;
    }
}

export interface IUnavailableReason {
    signalIds: number[];
    reason: string;
    detail?: string | undefined;
}

export class StatValueOfNullableBoolean implements IStatValueOfNullableBoolean {
    value?: boolean | undefined;
    status!: StatisticStatus;
    reasons?: UnavailableReason[] | undefined;

    constructor(data?: IStatValueOfNullableBoolean) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.status = _data["status"];
            if (Array.isArray(_data["reasons"])) {
                this.reasons = [] as any;
                for (let item of _data["reasons"])
                    this.reasons!.push(UnavailableReason.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StatValueOfNullableBoolean {
        data = typeof data === 'object' ? data : {};
        let result = new StatValueOfNullableBoolean();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["status"] = this.status;
        if (Array.isArray(this.reasons)) {
            data["reasons"] = [];
            for (let item of this.reasons)
                data["reasons"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IStatValueOfNullableBoolean {
    value?: boolean | undefined;
    status: StatisticStatus;
    reasons?: UnavailableReason[] | undefined;
}

export class StatValueOfString implements IStatValueOfString {
    value?: string | undefined;
    status!: StatisticStatus;
    reasons?: UnavailableReason[] | undefined;

    constructor(data?: IStatValueOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.status = _data["status"];
            if (Array.isArray(_data["reasons"])) {
                this.reasons = [] as any;
                for (let item of _data["reasons"])
                    this.reasons!.push(UnavailableReason.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StatValueOfString {
        data = typeof data === 'object' ? data : {};
        let result = new StatValueOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["status"] = this.status;
        if (Array.isArray(this.reasons)) {
            data["reasons"] = [];
            for (let item of this.reasons)
                data["reasons"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IStatValueOfString {
    value?: string | undefined;
    status: StatisticStatus;
    reasons?: UnavailableReason[] | undefined;
}

export class StatValueOfNullableInteger implements IStatValueOfNullableInteger {
    value?: number | undefined;
    status!: StatisticStatus;
    reasons?: UnavailableReason[] | undefined;

    constructor(data?: IStatValueOfNullableInteger) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.status = _data["status"];
            if (Array.isArray(_data["reasons"])) {
                this.reasons = [] as any;
                for (let item of _data["reasons"])
                    this.reasons!.push(UnavailableReason.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StatValueOfNullableInteger {
        data = typeof data === 'object' ? data : {};
        let result = new StatValueOfNullableInteger();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["status"] = this.status;
        if (Array.isArray(this.reasons)) {
            data["reasons"] = [];
            for (let item of this.reasons)
                data["reasons"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IStatValueOfNullableInteger {
    value?: number | undefined;
    status: StatisticStatus;
    reasons?: UnavailableReason[] | undefined;
}

export class StatValueOfListOfEngineLoadBucketDTO implements IStatValueOfListOfEngineLoadBucketDTO {
    value?: EngineLoadBucketDTO[] | undefined;
    status!: StatisticStatus;
    reasons?: UnavailableReason[] | undefined;

    constructor(data?: IStatValueOfListOfEngineLoadBucketDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(EngineLoadBucketDTO.fromJS(item));
            }
            this.status = _data["status"];
            if (Array.isArray(_data["reasons"])) {
                this.reasons = [] as any;
                for (let item of _data["reasons"])
                    this.reasons!.push(UnavailableReason.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StatValueOfListOfEngineLoadBucketDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StatValueOfListOfEngineLoadBucketDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item ? item.toJSON() : undefined as any);
        }
        data["status"] = this.status;
        if (Array.isArray(this.reasons)) {
            data["reasons"] = [];
            for (let item of this.reasons)
                data["reasons"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IStatValueOfListOfEngineLoadBucketDTO {
    value?: EngineLoadBucketDTO[] | undefined;
    status: StatisticStatus;
    reasons?: UnavailableReason[] | undefined;
}

export class EngineLoadBucketDTO implements IEngineLoadBucketDTO {
    lowerBound!: number;
    upperBound!: number;
    durationMinutes!: number;

    constructor(data?: IEngineLoadBucketDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lowerBound = _data["lowerBound"];
            this.upperBound = _data["upperBound"];
            this.durationMinutes = _data["durationMinutes"];
        }
    }

    static fromJS(data: any): EngineLoadBucketDTO {
        data = typeof data === 'object' ? data : {};
        let result = new EngineLoadBucketDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lowerBound"] = this.lowerBound;
        data["upperBound"] = this.upperBound;
        data["durationMinutes"] = this.durationMinutes;
        return data;
    }
}

export interface IEngineLoadBucketDTO {
    lowerBound: number;
    upperBound: number;
    durationMinutes: number;
}

export class TripStatisticDTO implements ITripStatisticDTO {
    statisticName!: string;
    moduleName!: string;
    status!: StatisticStatus;
    valueJson?: string | undefined;
    reasonsJson?: string | undefined;
    calculatedUtc!: DateTime;

    constructor(data?: ITripStatisticDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statisticName = _data["statisticName"];
            this.moduleName = _data["moduleName"];
            this.status = _data["status"];
            this.valueJson = _data["valueJson"];
            this.reasonsJson = _data["reasonsJson"];
            this.calculatedUtc = _data["calculatedUtc"] ? DateTime.fromISO(_data["calculatedUtc"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): TripStatisticDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TripStatisticDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statisticName"] = this.statisticName;
        data["moduleName"] = this.moduleName;
        data["status"] = this.status;
        data["valueJson"] = this.valueJson;
        data["reasonsJson"] = this.reasonsJson;
        data["calculatedUtc"] = this.calculatedUtc ? this.calculatedUtc.toString() : undefined as any;
        return data;
    }
}

export interface ITripStatisticDTO {
    statisticName: string;
    moduleName: string;
    status: StatisticStatus;
    valueJson?: string | undefined;
    reasonsJson?: string | undefined;
    calculatedUtc: DateTime;
}

export class PeriodicStatisticDTO implements IPeriodicStatisticDTO {
    statisticName!: string;
    moduleName!: string;
    periodType!: PeriodType;
    periodKey!: string;
    status!: StatisticStatus;
    valueJson?: string | undefined;
    reasonsJson?: string | undefined;
    calculatedUtc!: DateTime;

    constructor(data?: IPeriodicStatisticDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statisticName = _data["statisticName"];
            this.moduleName = _data["moduleName"];
            this.periodType = _data["periodType"];
            this.periodKey = _data["periodKey"];
            this.status = _data["status"];
            this.valueJson = _data["valueJson"];
            this.reasonsJson = _data["reasonsJson"];
            this.calculatedUtc = _data["calculatedUtc"] ? DateTime.fromISO(_data["calculatedUtc"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): PeriodicStatisticDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PeriodicStatisticDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statisticName"] = this.statisticName;
        data["moduleName"] = this.moduleName;
        data["periodType"] = this.periodType;
        data["periodKey"] = this.periodKey;
        data["status"] = this.status;
        data["valueJson"] = this.valueJson;
        data["reasonsJson"] = this.reasonsJson;
        data["calculatedUtc"] = this.calculatedUtc ? this.calculatedUtc.toString() : undefined as any;
        return data;
    }
}

export interface IPeriodicStatisticDTO {
    statisticName: string;
    moduleName: string;
    periodType: PeriodType;
    periodKey: string;
    status: StatisticStatus;
    valueJson?: string | undefined;
    reasonsJson?: string | undefined;
    calculatedUtc: DateTime;
}

export enum PeriodType {
    Daily = 0,
    Weekly = 1,
    Monthly = 2,
}

export class PagedResultDTOOfStatisticEventDTO implements IPagedResultDTOOfStatisticEventDTO {
    items?: StatisticEventDTO[] | undefined;
    totalNumberOfItems!: number;

    constructor(data?: IPagedResultDTOOfStatisticEventDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(StatisticEventDTO.fromJS(item));
            }
            this.totalNumberOfItems = _data["totalNumberOfItems"];
        }
    }

    static fromJS(data: any): PagedResultDTOOfStatisticEventDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDTOOfStatisticEventDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalNumberOfItems"] = this.totalNumberOfItems;
        return data;
    }
}

export interface IPagedResultDTOOfStatisticEventDTO {
    items?: StatisticEventDTO[] | undefined;
    totalNumberOfItems: number;
}

export class StatisticEventDTO implements IStatisticEventDTO {
    id!: number;
    vehicleId!: number;
    tripId?: number | undefined;
    eventType!: string;
    moduleName!: string;
    occurredUtc!: DateTime;
    valueJson?: string | undefined;
    severity?: number | undefined;

    constructor(data?: IStatisticEventDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.vehicleId = _data["vehicleId"];
            this.tripId = _data["tripId"];
            this.eventType = _data["eventType"];
            this.moduleName = _data["moduleName"];
            this.occurredUtc = _data["occurredUtc"] ? DateTime.fromISO(_data["occurredUtc"].toString()) : undefined as any;
            this.valueJson = _data["valueJson"];
            this.severity = _data["severity"];
        }
    }

    static fromJS(data: any): StatisticEventDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StatisticEventDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["vehicleId"] = this.vehicleId;
        data["tripId"] = this.tripId;
        data["eventType"] = this.eventType;
        data["moduleName"] = this.moduleName;
        data["occurredUtc"] = this.occurredUtc ? this.occurredUtc.toString() : undefined as any;
        data["valueJson"] = this.valueJson;
        data["severity"] = this.severity;
        return data;
    }
}

export interface IStatisticEventDTO {
    id: number;
    vehicleId: number;
    tripId?: number | undefined;
    eventType: string;
    moduleName: string;
    occurredUtc: DateTime;
    valueJson?: string | undefined;
    severity?: number | undefined;
}

export class PagedResultDTOOfDiagnosticEventDTO implements IPagedResultDTOOfDiagnosticEventDTO {
    items?: DiagnosticEventDTO[] | undefined;
    totalNumberOfItems!: number;

    constructor(data?: IPagedResultDTOOfDiagnosticEventDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DiagnosticEventDTO.fromJS(item));
            }
            this.totalNumberOfItems = _data["totalNumberOfItems"];
        }
    }

    static fromJS(data: any): PagedResultDTOOfDiagnosticEventDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDTOOfDiagnosticEventDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalNumberOfItems"] = this.totalNumberOfItems;
        return data;
    }
}

export interface IPagedResultDTOOfDiagnosticEventDTO {
    items?: DiagnosticEventDTO[] | undefined;
    totalNumberOfItems: number;
}

export class DiagnosticEventDTO implements IDiagnosticEventDTO {
    id!: number;
    vehicleId!: number;
    ecuId?: number | undefined;
    timestamp!: DateTime;
    eventType!: string;
    dtc?: string | undefined;
    freezeFrame?: FreezeFrameDetailDTO | undefined;
    additionalData?: string | undefined;

    constructor(data?: IDiagnosticEventDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.vehicleId = _data["vehicleId"];
            this.ecuId = _data["ecuId"];
            this.timestamp = _data["timestamp"] ? DateTime.fromISO(_data["timestamp"].toString()) : undefined as any;
            this.eventType = _data["eventType"];
            this.dtc = _data["dtc"];
            this.freezeFrame = _data["freezeFrame"] ? FreezeFrameDetailDTO.fromJS(_data["freezeFrame"]) : undefined as any;
            this.additionalData = _data["additionalData"];
        }
    }

    static fromJS(data: any): DiagnosticEventDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DiagnosticEventDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["vehicleId"] = this.vehicleId;
        data["ecuId"] = this.ecuId;
        data["timestamp"] = this.timestamp ? this.timestamp.toString() : undefined as any;
        data["eventType"] = this.eventType;
        data["dtc"] = this.dtc;
        data["freezeFrame"] = this.freezeFrame ? this.freezeFrame.toJSON() : undefined as any;
        data["additionalData"] = this.additionalData;
        return data;
    }
}

export interface IDiagnosticEventDTO {
    id: number;
    vehicleId: number;
    ecuId?: number | undefined;
    timestamp: DateTime;
    eventType: string;
    dtc?: string | undefined;
    freezeFrame?: FreezeFrameDetailDTO | undefined;
    additionalData?: string | undefined;
}

export class FreezeFrameDetailDTO implements IFreezeFrameDetailDTO {
    freezeFrameId?: string | undefined;
    capturedUtc!: DateTime;
    measurements!: FreezeFrameMeasurementDetailDTO[];

    constructor(data?: IFreezeFrameDetailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.measurements = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.freezeFrameId = _data["freezeFrameId"];
            this.capturedUtc = _data["capturedUtc"] ? DateTime.fromISO(_data["capturedUtc"].toString()) : undefined as any;
            if (Array.isArray(_data["measurements"])) {
                this.measurements = [] as any;
                for (let item of _data["measurements"])
                    this.measurements!.push(FreezeFrameMeasurementDetailDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FreezeFrameDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FreezeFrameDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["freezeFrameId"] = this.freezeFrameId;
        data["capturedUtc"] = this.capturedUtc ? this.capturedUtc.toString() : undefined as any;
        if (Array.isArray(this.measurements)) {
            data["measurements"] = [];
            for (let item of this.measurements)
                data["measurements"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFreezeFrameDetailDTO {
    freezeFrameId?: string | undefined;
    capturedUtc: DateTime;
    measurements: FreezeFrameMeasurementDetailDTO[];
}

export class FreezeFrameMeasurementDetailDTO implements IFreezeFrameMeasurementDetailDTO {
    signalId!: number;
    signalName?: string | undefined;
    unit?: string | undefined;
    value!: number;

    constructor(data?: IFreezeFrameMeasurementDetailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.signalId = _data["signalId"];
            this.signalName = _data["signalName"];
            this.unit = _data["unit"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): FreezeFrameMeasurementDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FreezeFrameMeasurementDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["signalId"] = this.signalId;
        data["signalName"] = this.signalName;
        data["unit"] = this.unit;
        data["value"] = this.value;
        return data;
    }
}

export interface IFreezeFrameMeasurementDetailDTO {
    signalId: number;
    signalName?: string | undefined;
    unit?: string | undefined;
    value: number;
}

export class ChartDataDTO implements IChartDataDTO {
    statisticName!: string;
    fromUtc!: DateTime;
    toUtc!: DateTime;
    points!: ChartDataPointDTO[];
    unavailableReason?: string | undefined;

    constructor(data?: IChartDataDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.points = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statisticName = _data["statisticName"];
            this.fromUtc = _data["fromUtc"] ? DateTime.fromISO(_data["fromUtc"].toString()) : undefined as any;
            this.toUtc = _data["toUtc"] ? DateTime.fromISO(_data["toUtc"].toString()) : undefined as any;
            if (Array.isArray(_data["points"])) {
                this.points = [] as any;
                for (let item of _data["points"])
                    this.points!.push(ChartDataPointDTO.fromJS(item));
            }
            this.unavailableReason = _data["unavailableReason"];
        }
    }

    static fromJS(data: any): ChartDataDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ChartDataDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statisticName"] = this.statisticName;
        data["fromUtc"] = this.fromUtc ? this.fromUtc.toString() : undefined as any;
        data["toUtc"] = this.toUtc ? this.toUtc.toString() : undefined as any;
        if (Array.isArray(this.points)) {
            data["points"] = [];
            for (let item of this.points)
                data["points"].push(item ? item.toJSON() : undefined as any);
        }
        data["unavailableReason"] = this.unavailableReason;
        return data;
    }
}

export interface IChartDataDTO {
    statisticName: string;
    fromUtc: DateTime;
    toUtc: DateTime;
    points: ChartDataPointDTO[];
    unavailableReason?: string | undefined;
}

export class ChartDataPointDTO implements IChartDataPointDTO {
    timestampUtc!: DateTime;
    value!: number;

    constructor(data?: IChartDataPointDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timestampUtc = _data["timestampUtc"] ? DateTime.fromISO(_data["timestampUtc"].toString()) : undefined as any;
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): ChartDataPointDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ChartDataPointDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timestampUtc"] = this.timestampUtc ? this.timestampUtc.toString() : undefined as any;
        data["value"] = this.value;
        return data;
    }
}

export interface IChartDataPointDTO {
    timestampUtc: DateTime;
    value: number;
}

export enum OnDemandStatistic {
    InstantFuelConsumption = 0,
    BatteryVoltageHistory = 1,
    RpmHistory = 2,
    SpeedHistory = 3,
}

export class RecomputeScheduledRequestDTO implements IRecomputeScheduledRequestDTO {
    vehicleId!: number;

    constructor(data?: IRecomputeScheduledRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicleId = _data["vehicleId"];
        }
    }

    static fromJS(data: any): RecomputeScheduledRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RecomputeScheduledRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vehicleId"] = this.vehicleId;
        return data;
    }
}

export interface IRecomputeScheduledRequestDTO {
    vehicleId: number;
}

export class ClientThemeDTO implements IClientThemeDTO {
    primary?: string | undefined;
    secondary?: string | undefined;
    logoUrl?: string | undefined;
    logoUrlDarkMode?: string | undefined;
    overrides?: ThemeOverridesDTO | undefined;

    constructor(data?: IClientThemeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.primary = _data["primary"];
            this.secondary = _data["secondary"];
            this.logoUrl = _data["logoUrl"];
            this.logoUrlDarkMode = _data["logoUrlDarkMode"];
            this.overrides = _data["overrides"] ? ThemeOverridesDTO.fromJS(_data["overrides"]) : undefined as any;
        }
    }

    static fromJS(data: any): ClientThemeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ClientThemeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["primary"] = this.primary;
        data["secondary"] = this.secondary;
        data["logoUrl"] = this.logoUrl;
        data["logoUrlDarkMode"] = this.logoUrlDarkMode;
        data["overrides"] = this.overrides ? this.overrides.toJSON() : undefined as any;
        return data;
    }
}

export interface IClientThemeDTO {
    primary?: string | undefined;
    secondary?: string | undefined;
    logoUrl?: string | undefined;
    logoUrlDarkMode?: string | undefined;
    overrides?: ThemeOverridesDTO | undefined;
}

export class ThemeOverridesDTO implements IThemeOverridesDTO {
    light!: { [key: string]: string; };
    dark!: { [key: string]: string; };

    constructor(data?: IThemeOverridesDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.light = {};
            this.dark = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["light"]) {
                this.light = {} as any;
                for (let key in _data["light"]) {
                    if (_data["light"].hasOwnProperty(key))
                        (this.light as any)![key] = _data["light"][key];
                }
            }
            if (_data["dark"]) {
                this.dark = {} as any;
                for (let key in _data["dark"]) {
                    if (_data["dark"].hasOwnProperty(key))
                        (this.dark as any)![key] = _data["dark"][key];
                }
            }
        }
    }

    static fromJS(data: any): ThemeOverridesDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeOverridesDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.light) {
            data["light"] = {};
            for (let key in this.light) {
                if (this.light.hasOwnProperty(key))
                    (data["light"] as any)[key] = (this.light as any)[key];
            }
        }
        if (this.dark) {
            data["dark"] = {};
            for (let key in this.dark) {
                if (this.dark.hasOwnProperty(key))
                    (data["dark"] as any)[key] = (this.dark as any)[key];
            }
        }
        return data;
    }
}

export interface IThemeOverridesDTO {
    light: { [key: string]: string; };
    dark: { [key: string]: string; };
}

export class UserInfoDTO implements IUserInfoDTO {
    userId?: string | undefined;
    clientId?: number | undefined;
    client?: ClientDTO | undefined;
    userName?: string | undefined;
    password?: string | undefined;
    firstname?: string | undefined;
    lastname?: string | undefined;
    language?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    roles?: Role[] | undefined;
    enabled!: boolean;
    accessCode?: string | undefined;
    accessCodeValidUntil?: DateTime | undefined;
    accessCodeGeneratedOn?: DateTime | undefined;
    accessCodeUsedOn?: DateTime | undefined;
    permanentAccessCode!: boolean;

    constructor(data?: IUserInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.clientId = _data["clientId"];
            this.client = _data["client"] ? ClientDTO.fromJS(_data["client"]) : undefined as any;
            this.userName = _data["userName"];
            this.password = _data["password"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
            this.language = _data["language"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            this.enabled = _data["enabled"];
            this.accessCode = _data["accessCode"];
            this.accessCodeValidUntil = _data["accessCodeValidUntil"] ? DateTime.fromISO(_data["accessCodeValidUntil"].toString()) : undefined as any;
            this.accessCodeGeneratedOn = _data["accessCodeGeneratedOn"] ? DateTime.fromISO(_data["accessCodeGeneratedOn"].toString()) : undefined as any;
            this.accessCodeUsedOn = _data["accessCodeUsedOn"] ? DateTime.fromISO(_data["accessCodeUsedOn"].toString()) : undefined as any;
            this.permanentAccessCode = _data["permanentAccessCode"];
        }
    }

    static fromJS(data: any): UserInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["clientId"] = this.clientId;
        data["client"] = this.client ? this.client.toJSON() : undefined as any;
        data["userName"] = this.userName;
        data["password"] = this.password;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        data["language"] = this.language;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["enabled"] = this.enabled;
        data["accessCode"] = this.accessCode;
        data["accessCodeValidUntil"] = this.accessCodeValidUntil ? this.accessCodeValidUntil.toString() : undefined as any;
        data["accessCodeGeneratedOn"] = this.accessCodeGeneratedOn ? this.accessCodeGeneratedOn.toString() : undefined as any;
        data["accessCodeUsedOn"] = this.accessCodeUsedOn ? this.accessCodeUsedOn.toString() : undefined as any;
        data["permanentAccessCode"] = this.permanentAccessCode;
        return data;
    }
}

export interface IUserInfoDTO {
    userId?: string | undefined;
    clientId?: number | undefined;
    client?: ClientDTO | undefined;
    userName?: string | undefined;
    password?: string | undefined;
    firstname?: string | undefined;
    lastname?: string | undefined;
    language?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    roles?: Role[] | undefined;
    enabled: boolean;
    accessCode?: string | undefined;
    accessCodeValidUntil?: DateTime | undefined;
    accessCodeGeneratedOn?: DateTime | undefined;
    accessCodeUsedOn?: DateTime | undefined;
    permanentAccessCode: boolean;
}

export enum Role {
    None = 0,
    Admin = 1,
    ClientAdmin = 2,
    WebUser = 3,
    MobileUser = 4,
    RestService = 5,
}

export class PagedResultDTOOfUserInfoDTO implements IPagedResultDTOOfUserInfoDTO {
    items?: UserInfoDTO[] | undefined;
    totalNumberOfItems!: number;

    constructor(data?: IPagedResultDTOOfUserInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserInfoDTO.fromJS(item));
            }
            this.totalNumberOfItems = _data["totalNumberOfItems"];
        }
    }

    static fromJS(data: any): PagedResultDTOOfUserInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDTOOfUserInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalNumberOfItems"] = this.totalNumberOfItems;
        return data;
    }
}

export interface IPagedResultDTOOfUserInfoDTO {
    items?: UserInfoDTO[] | undefined;
    totalNumberOfItems: number;
}

export class UpdateUserInfoDTO implements IUpdateUserInfoDTO {
    userId!: string;
    clientId?: number | undefined;
    email?: string | undefined;
    enabled?: boolean | undefined;
    firstname?: string | undefined;
    lastname?: string | undefined;
    language?: string | undefined;
    phoneNumber?: string | undefined;
    userName?: string | undefined;
    roles?: Role[] | undefined;
    accessCodeValidUntil?: DateTime | undefined;

    constructor(data?: IUpdateUserInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.clientId = _data["clientId"];
            this.email = _data["email"];
            this.enabled = _data["enabled"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
            this.language = _data["language"];
            this.phoneNumber = _data["phoneNumber"];
            this.userName = _data["userName"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            this.accessCodeValidUntil = _data["accessCodeValidUntil"] ? DateTime.fromISO(_data["accessCodeValidUntil"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): UpdateUserInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["clientId"] = this.clientId;
        data["email"] = this.email;
        data["enabled"] = this.enabled;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        data["language"] = this.language;
        data["phoneNumber"] = this.phoneNumber;
        data["userName"] = this.userName;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["accessCodeValidUntil"] = this.accessCodeValidUntil ? this.accessCodeValidUntil.toString() : undefined as any;
        return data;
    }
}

export interface IUpdateUserInfoDTO {
    userId: string;
    clientId?: number | undefined;
    email?: string | undefined;
    enabled?: boolean | undefined;
    firstname?: string | undefined;
    lastname?: string | undefined;
    language?: string | undefined;
    phoneNumber?: string | undefined;
    userName?: string | undefined;
    roles?: Role[] | undefined;
    accessCodeValidUntil?: DateTime | undefined;
}

export class CreateMobileUserDTO implements ICreateMobileUserDTO {
    clientId!: number;
    email!: string;
    employeeNumber?: string | undefined;
    firstname!: string;
    lastname!: string;
    language?: string | undefined;
    phoneNumber?: string | undefined;

    constructor(data?: ICreateMobileUserDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.email = _data["email"];
            this.employeeNumber = _data["employeeNumber"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
            this.language = _data["language"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): CreateMobileUserDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMobileUserDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["email"] = this.email;
        data["employeeNumber"] = this.employeeNumber;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        data["language"] = this.language;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface ICreateMobileUserDTO {
    clientId: number;
    email: string;
    employeeNumber?: string | undefined;
    firstname: string;
    lastname: string;
    language?: string | undefined;
    phoneNumber?: string | undefined;
}

export class CreateUserDTO implements ICreateUserDTO {
    clientId?: number | undefined;
    email!: string;
    firstname!: string;
    lastname!: string;
    language?: string | undefined;
    phoneNumber?: string | undefined;
    password?: string | undefined;
    roles?: Role[] | undefined;

    constructor(data?: ICreateUserDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.email = _data["email"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
            this.language = _data["language"];
            this.phoneNumber = _data["phoneNumber"];
            this.password = _data["password"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateUserDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["email"] = this.email;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        data["language"] = this.language;
        data["phoneNumber"] = this.phoneNumber;
        data["password"] = this.password;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        return data;
    }
}

export interface ICreateUserDTO {
    clientId?: number | undefined;
    email: string;
    firstname: string;
    lastname: string;
    language?: string | undefined;
    phoneNumber?: string | undefined;
    password?: string | undefined;
    roles?: Role[] | undefined;
}

export class ChangePasswordDTO implements IChangePasswordDTO {
    oldPassword!: string;
    newPassword!: string;

    constructor(data?: IChangePasswordDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oldPassword = _data["oldPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldPassword"] = this.oldPassword;
        data["newPassword"] = this.newPassword;
        return data;
    }
}

export interface IChangePasswordDTO {
    oldPassword: string;
    newPassword: string;
}

export class SetPasswordDTO implements ISetPasswordDTO {
    newPassword!: string;
    verificationToken!: string;
    userId!: string;
    forgotPasswordProcess?: boolean | undefined;

    constructor(data?: ISetPasswordDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newPassword = _data["newPassword"];
            this.verificationToken = _data["verificationToken"];
            this.userId = _data["userId"];
            this.forgotPasswordProcess = _data["forgotPasswordProcess"];
        }
    }

    static fromJS(data: any): SetPasswordDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SetPasswordDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newPassword"] = this.newPassword;
        data["verificationToken"] = this.verificationToken;
        data["userId"] = this.userId;
        data["forgotPasswordProcess"] = this.forgotPasswordProcess;
        return data;
    }
}

export interface ISetPasswordDTO {
    newPassword: string;
    verificationToken: string;
    userId: string;
    forgotPasswordProcess?: boolean | undefined;
}

export class ForgotPasswordDTO implements IForgotPasswordDTO {
    username!: string;

    constructor(data?: IForgotPasswordDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
        }
    }

    static fromJS(data: any): ForgotPasswordDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ForgotPasswordDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        return data;
    }
}

export interface IForgotPasswordDTO {
    username: string;
}

export class MinimumClientVersionDTO implements IMinimumClientVersionDTO {
    minimumClientVersion?: string | undefined;

    constructor(data?: IMinimumClientVersionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.minimumClientVersion = _data["minimumClientVersion"];
        }
    }

    static fromJS(data: any): MinimumClientVersionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MinimumClientVersionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minimumClientVersion"] = this.minimumClientVersion;
        return data;
    }
}

export interface IMinimumClientVersionDTO {
    minimumClientVersion?: string | undefined;
}

export class VehicleMetadataRequestDto implements IVehicleMetadataRequestDto {
    collectorId!: string;
    vehicle?: VehicleDto | undefined;
    vehicleProtocols!: VehicleProtocolDto[];
    ecUs!: EcuDto[];

    constructor(data?: IVehicleMetadataRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.vehicleProtocols = [];
            this.ecUs = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.collectorId = _data["collectorId"];
            this.vehicle = _data["vehicle"] ? VehicleDto.fromJS(_data["vehicle"]) : undefined as any;
            if (Array.isArray(_data["vehicleProtocols"])) {
                this.vehicleProtocols = [] as any;
                for (let item of _data["vehicleProtocols"])
                    this.vehicleProtocols!.push(VehicleProtocolDto.fromJS(item));
            }
            if (Array.isArray(_data["ecUs"])) {
                this.ecUs = [] as any;
                for (let item of _data["ecUs"])
                    this.ecUs!.push(EcuDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VehicleMetadataRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleMetadataRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["collectorId"] = this.collectorId;
        data["vehicle"] = this.vehicle ? this.vehicle.toJSON() : undefined as any;
        if (Array.isArray(this.vehicleProtocols)) {
            data["vehicleProtocols"] = [];
            for (let item of this.vehicleProtocols)
                data["vehicleProtocols"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.ecUs)) {
            data["ecUs"] = [];
            for (let item of this.ecUs)
                data["ecUs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IVehicleMetadataRequestDto {
    collectorId: string;
    vehicle?: VehicleDto | undefined;
    vehicleProtocols: VehicleProtocolDto[];
    ecUs: EcuDto[];
}

export class VehicleDto implements IVehicleDto {
    vin?: string | undefined;
    manufacturer?: string | undefined;
    brand?: string | undefined;
    model?: string | undefined;
    modelYear!: number;
    engine?: string | undefined;
    transmission?: string | undefined;
    fuelType?: string | undefined;
    emissionStandard?: string | undefined;
    platform?: string | undefined;
    supportedProtocols?: string | undefined;
    gatewayPresent!: boolean;

    constructor(data?: IVehicleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vin = _data["vin"];
            this.manufacturer = _data["manufacturer"];
            this.brand = _data["brand"];
            this.model = _data["model"];
            this.modelYear = _data["modelYear"];
            this.engine = _data["engine"];
            this.transmission = _data["transmission"];
            this.fuelType = _data["fuelType"];
            this.emissionStandard = _data["emissionStandard"];
            this.platform = _data["platform"];
            this.supportedProtocols = _data["supportedProtocols"];
            this.gatewayPresent = _data["gatewayPresent"];
        }
    }

    static fromJS(data: any): VehicleDto {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vin"] = this.vin;
        data["manufacturer"] = this.manufacturer;
        data["brand"] = this.brand;
        data["model"] = this.model;
        data["modelYear"] = this.modelYear;
        data["engine"] = this.engine;
        data["transmission"] = this.transmission;
        data["fuelType"] = this.fuelType;
        data["emissionStandard"] = this.emissionStandard;
        data["platform"] = this.platform;
        data["supportedProtocols"] = this.supportedProtocols;
        data["gatewayPresent"] = this.gatewayPresent;
        return data;
    }
}

export interface IVehicleDto {
    vin?: string | undefined;
    manufacturer?: string | undefined;
    brand?: string | undefined;
    model?: string | undefined;
    modelYear: number;
    engine?: string | undefined;
    transmission?: string | undefined;
    fuelType?: string | undefined;
    emissionStandard?: string | undefined;
    platform?: string | undefined;
    supportedProtocols?: string | undefined;
    gatewayPresent: boolean;
}

export class VehicleProtocolDto implements IVehicleProtocolDto {
    protocol!: string;
    version?: string | undefined;

    constructor(data?: IVehicleProtocolDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.protocol = _data["protocol"];
            this.version = _data["version"];
        }
    }

    static fromJS(data: any): VehicleProtocolDto {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleProtocolDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["protocol"] = this.protocol;
        data["version"] = this.version;
        return data;
    }
}

export interface IVehicleProtocolDto {
    protocol: string;
    version?: string | undefined;
}

export class EcuDto implements IEcuDto {
    ecuId!: string;
    name?: string | undefined;
    address?: string | undefined;
    canId?: string | undefined;
    softwareVersion?: string | undefined;
    hardwareVersion?: string | undefined;
    serialNumber?: string | undefined;
    coding?: string | undefined;
    supportedServices?: string | undefined;
    supportedDTCClasses?: string | undefined;

    constructor(data?: IEcuDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ecuId = _data["ecuId"];
            this.name = _data["name"];
            this.address = _data["address"];
            this.canId = _data["canId"];
            this.softwareVersion = _data["softwareVersion"];
            this.hardwareVersion = _data["hardwareVersion"];
            this.serialNumber = _data["serialNumber"];
            this.coding = _data["coding"];
            this.supportedServices = _data["supportedServices"];
            this.supportedDTCClasses = _data["supportedDTCClasses"];
        }
    }

    static fromJS(data: any): EcuDto {
        data = typeof data === 'object' ? data : {};
        let result = new EcuDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ecuId"] = this.ecuId;
        data["name"] = this.name;
        data["address"] = this.address;
        data["canId"] = this.canId;
        data["softwareVersion"] = this.softwareVersion;
        data["hardwareVersion"] = this.hardwareVersion;
        data["serialNumber"] = this.serialNumber;
        data["coding"] = this.coding;
        data["supportedServices"] = this.supportedServices;
        data["supportedDTCClasses"] = this.supportedDTCClasses;
        return data;
    }
}

export interface IEcuDto {
    ecuId: string;
    name?: string | undefined;
    address?: string | undefined;
    canId?: string | undefined;
    softwareVersion?: string | undefined;
    hardwareVersion?: string | undefined;
    serialNumber?: string | undefined;
    coding?: string | undefined;
    supportedServices?: string | undefined;
    supportedDTCClasses?: string | undefined;
}

export class PagedResultDTOOfVehicleListDTO implements IPagedResultDTOOfVehicleListDTO {
    items?: VehicleListDTO[] | undefined;
    totalNumberOfItems!: number;

    constructor(data?: IPagedResultDTOOfVehicleListDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(VehicleListDTO.fromJS(item));
            }
            this.totalNumberOfItems = _data["totalNumberOfItems"];
        }
    }

    static fromJS(data: any): PagedResultDTOOfVehicleListDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDTOOfVehicleListDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalNumberOfItems"] = this.totalNumberOfItems;
        return data;
    }
}

export interface IPagedResultDTOOfVehicleListDTO {
    items?: VehicleListDTO[] | undefined;
    totalNumberOfItems: number;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}